// 全局loading
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";
import store from "@/store";
import {
  rlJointData,
  rlGridData,
  rlGridArcData,
  rlAxisData,
  rlAxisArcData,
  rlWallData,
  rlWallHoleData,
  rlColumnData,
  rlRingBeamData,
  rlSlabData,
  rlSlabHoleData,
  rlSubBeamData,
  rlBeamData,
  rlPartitionWallData,
  rlDoorsWindowsData,
  rlUseData,
  rlCantiSlabData,
} from "@/rlMxModules/rlDataClass/index";
import { getpickstatusall } from "@/api/modelingList.js";

import {
  addEntityToDrawing,
  getEntityData,
  toggleAxisDist,
} from "@/rlMxModules/operate/operateApi";

import { generate_guid } from "@/rlMxModules/utils/util";

// 接口数据
import { getTotalFloorData } from "@/api/cadList";

import { initRevokeReDoData } from "@/rlMxModules/operate/revokeRollback";

// 数据库操作
import {
  getrlFloor,
  addrlStdFlr,
  getrlStdFlrAll,
  resetAllRlFloor,
  resetAllRlStdFlr,
  resetAllRlColSect,
  resetAllRlBeamSect,
  resetAllRlWallSect,
  resetAllRlSlabSect,
  resetAllrlPartitionWallSect,
  resetAllrlDoorsWindowsDef,
  resetAllRlLayer,
  getRlModules,
  getRlLayer,
  resetAllRlRingBeamSect,
  resetAllRlWallHoleDef,
  resetAllRlslabholedef,
  updateBulkRlStdFlrFieldDatas,
  delBulkRlStdFlrFieldDatas,
  getRlInitFloorData,
  resetAllRlCantiSlabDef,
  getAllDataWithDexie,
} from "@/mixins/LiteModuleDb.js";
import { getrlStdFlr } from "@/mixins/LiteModuleDb.js";

import {
  getNonStructuralColor,
  calculate_cantiSlab_dr_params,
  MovePt,
} from "@/rlMxModules/operate/structural";
import { uperrormodel } from "@/api/user";
// 更新三维
import { update3Dview } from "@/rlMxModules/threeObject/threeView";
import { LOG } from "@zxing/library/esm/core/datamatrix/encoder/constants";
import mxcad from "mxcad";
const { McGePoint3d, McCmColor } = mxcad;
import { getArcPoints } from "@/rlMxModules/Opencascad/getModelDrawData.js";
//获取数据
export const initAllData = async () => {
  //接口获取数据 - 248
  try {
    // 自然层
    const rlfloorData = await getTotalFloorData("rlfloor");
    await resetAllRlFloor(rlfloorData.data);
    // 标准层
    const rlstdflrData = await getTotalFloorData("rlstdflr");
    await resetAllRlStdFlr(rlstdflrData.data);
    // 柱截面
    const rlcolsectData = await getTotalFloorData("rlcolsect");
    await resetAllRlColSect(rlcolsectData.data);
    // 梁截面
    const rlbeamsectData = await getTotalFloorData("rlbeamsect");
    await resetAllRlBeamSect(rlbeamsectData.data);
    // 墙截面
    const rlwallsectData = await getTotalFloorData("rlwallsect");
    await resetAllRlWallSect(rlwallsectData.data);
    // 板截面
    const rlslabsectData = await getTotalFloorData("rlslabsect");
    await resetAllRlSlabSect(rlslabsectData.data);
    // 墙洞截面
    const rlWallHoleDefData = await getTotalFloorData("rlWallHoleDef");
    await resetAllRlWallHoleDef(rlWallHoleDefData.data);
    // 圈梁截面
    const rlringbeamsectData = await getTotalFloorData("rlringbeamsect");
    await resetAllRlRingBeamSect(rlringbeamsectData.data);

    // 板洞数据
    const rlSlabHoleDefData = await getTotalFloorData("rlSlabHoleDef");
    await resetAllRlslabholedef(rlSlabHoleDefData.data);

    // 隔墙数据
    const rlPartitionWallSect = await getTotalFloorData("rlpartitionwallsect");
    await resetAllrlPartitionWallSect(rlPartitionWallSect.data);

    // 门窗数据
    const rlDoorsWindowsDef = await getTotalFloorData("rldoorswindowsdef");
    await resetAllrlDoorsWindowsDef(rlDoorsWindowsDef.data);

    // 悬挑板截面
    const rlCantiSlabDef = await getTotalFloorData("rlCantiSlabDef");
    await resetAllRlCantiSlabDef(rlCantiSlabDef.data);

    // 图层
    const rllayerData = await getTotalFloorData("rllayer");
    await resetAllRlLayer(rllayerData.data);

    // 获取最大序号
    const rlstructnumData = await getTotalFloorData("maxNo");

    store.commit("globalData/setStructNum", rlstructnumData.data);
    return "新增成功";
  } catch (error) {
    return error;
  }
  //将数据分别存入indexdb
};

//绘制指定标准层的节点
export const drawStdFlrJointData = (jointData, currFlrLevelB) => {
  try {
    if (!jointData) return null;

    // //添加一条假数据
    // jointData["1234567890"] = {
    //   Guid: "1234567890",
    //   X: 0,
    //   Y: 0,
    //   Z: 0,
    //   OtherData: "",
    //   StdFlrGuid: Object.keys(jointData)[0],
    // };

    // jointData["asdfghhjk"] = {
    //   Guid: "asdfghhjk",
    //   X: 1000,
    //   Y: 0,
    //   Z: 0,
    //   OtherData: "",
    //   StdFlrGuid: Object.keys(jointData)[0].StdFlrGuid,
    // };

    // jointData["qwerertuy"] = {
    //   Guid: "qwerertuy",
    //   X: 0,
    //   Y: 1000,
    //   Z: 0,
    //   OtherData: "",
    //   StdFlrGuid: Object.keys(jointData)[0].StdFlrGuid,
    // };

    // console.log("jointData11111", jointData);

    let jointKeyValue = {};
    let guids = Object.keys(jointData);
    let index = 0;
    let batchSize = 100; // 每批处理的实体数量，可根据实际情况调整

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = jointData[guid];

          if (dataObj) {
            let rlPointObj = new rlJointData();
            rlPointObj.initData({
              m_pt: [dataObj["X"], dataObj["Y"], currFlrLevelB],
              StdFlrGuid: dataObj.StdFlrGuid,
              Guid: dataObj.Guid,
              HDiff: dataObj.HDiff ? Number(dataObj.HDiff) : 0,
            });

            jointKeyValue[dataObj.Guid] = rlPointObj;

            // 将绘制操作添加到 promises 数组中，便于并发处理
            promises.push(addEntityToDrawing(rlPointObj, true));
          }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            // 使用 queueMicrotask 让出主线程
            queueMicrotask(processBatch);
          } else {
            resolve(jointKeyValue);
          }
        });
      }

      processBatch();
    });
  } catch (error) {
    console.error("绘制节点时出错：", error);
    return null;
  }
};

//绘制指定标准层的轴线
export const drawStdFlrAxisData = (axisData, jointKeyValue, gridData) => {
  try {
    if (!jointKeyValue || !axisData) return null;

    let axisKeyValue = {};
    let unvalidData = [];
    let guids = Object.keys(axisData);
    let index = 0;
    let batchSize = 100; // 批次处理大小

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = axisData[guid];

          if (!dataObj) continue;

          const jt1 = jointKeyValue[dataObj.Jt1Guid];
          const jt2 = jointKeyValue[dataObj.Jt2Guid];

          if (jt1 && jt2) {
            let rlAxisObj = null;
            if (dataObj.IsMainAxis < 0 && gridData) {
              let grid = Object.values(gridData).filter(
                (item) => item.AxisGuid == guid
              );

              if (grid && grid.length) {
                rlAxisObj = new rlAxisArcData();
                rlAxisObj.initData({
                  m_stJoint: jt1,
                  m_edJoint: jt2,
                  m_stArcPoint: getEntityData({
                    Guid: grid[0].Jt1Guid,
                    classTypeName: "rlJoint",
                  })?.m_pt,
                  m_edArcPoint: getEntityData({
                    Guid: grid[0].Jt2Guid,
                    classTypeName: "rlJoint",
                  })?.m_pt,
                  IsMainAxis: dataObj.IsMainAxis,
                  Name: dataObj.Name,
                  Guid: dataObj.Guid,
                  StdFlrGuid: dataObj.StdFlrGuid,
                  isShow: dataObj.IsShow,
                });
              }
            } else {
              rlAxisObj = new rlAxisData();
              rlAxisObj.initData({
                m_stJoint: jt1,
                m_edJoint: jt2,
                IsMainAxis: dataObj.IsMainAxis,
                Name: dataObj.Name,
                Guid: dataObj.Guid,
                StdFlrGuid: dataObj.StdFlrGuid,
                isShow: dataObj.IsShow,
              });
            }
            if (rlAxisObj) {
              axisKeyValue[dataObj.Guid] = rlAxisObj;

              // 并行执行绘制操作
              promises.push(addEntityToDrawing(rlAxisObj, true));
            }
          } else {
            unvalidData.push(dataObj);
          }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            // 继续处理下一批数据
            queueMicrotask(processBatch);
          } else {
            // 所有批次完成，返回最终结果
            resolve({ axisKeyValue, unvalidData });
          }
        });
      }

      processBatch();
    });
  } catch (error) {
    console.error("绘制轴线时出错：", error);
    return null;
  }
};

//绘制指定标准层的网格
export const drawStdFlrGridData = async (
  gridData,
  jointKeyValue,
  axisKeyValue
) => {
  try {
    if (!jointKeyValue || !axisKeyValue || !gridData) return null;

    // //添加一条假数据
    // gridData["11222222222"] = {
    //   Guid: "11222222222",
    //   AxisGuid: "poiuytrewq",
    //   Jt1Guid: "asdfghhjk",
    //   Jt2Guid: "qwerertuy",
    //   OtherData: "",
    //   StdFlrGuid: Object.keys(gridData)[0].StdFlrGuid,
    // };

    let gridKeyValue = {};
    let unvalidData = [];
    let updateObjs = [];
    let guids = Object.keys(gridData);
    let index = 0;
    let batchSize = 100; // 每批处理的实体数量，可以根据实际情况调整

    return new Promise((resolve, reject) => {
      async function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = gridData[guid];

          // 减少判断的复杂度
          if (!dataObj) continue;
          const jt1 = jointKeyValue[dataObj.Jt1Guid];
          const jt2 = jointKeyValue[dataObj.Jt2Guid];
          const axis = axisKeyValue[dataObj.AxisGuid];

          //dataObj.Jt1Guid != dataObj.Jt2Guid:发现有网格的两个点都一直的情况,不知道怎么出现的
          if (jt1 && jt2 /* && axis*/ && dataObj.Jt1Guid != dataObj.Jt2Guid) {
            let rlLineGridObj = null;
            if (dataObj.Jt0Guid || (axis && axis.IsMainAxis < 0)) {
              let centerPoint = null;
              if (dataObj.Jt0Guid && jointKeyValue[dataObj.Jt0Guid]) {
                centerPoint = jointKeyValue[dataObj.Jt0Guid].m_pt;
              } else {
                dataObj.Jt0Guid = axis.m_stJoint.Guid;
                centerPoint = axis.m_stJoint.m_pt;
                updateObjs.push(dataObj);
              }
              rlLineGridObj = new rlGridArcData(); // 简化对象创建
              rlLineGridObj.initData({
                m_centerJoint: dataObj.Jt0Guid
                  ? jointKeyValue[dataObj.Jt0Guid]
                  : null,
                m_stJoint: jt1,
                m_edJoint: jt2,
                centerPoint: centerPoint,
                StdFlrGuid: dataObj.StdFlrGuid,
                m_Axis: axis,
                Guid: dataObj.Guid,
              });
            } else {
              rlLineGridObj = new rlGridData(); // 简化对象创建
              rlLineGridObj.initData({
                m_stJoint: jt1,
                m_edJoint: jt2,
                StdFlrGuid: dataObj.StdFlrGuid,
                m_Axis: axis,
                Guid: dataObj.Guid,
              });
            }

            gridKeyValue[dataObj.Guid] = rlLineGridObj;

            promises.push(addEntityToDrawing(rlLineGridObj, true)); // 并发添加绘制
          } else {
            unvalidData.push(dataObj);
          }
        }
        await Promise.all(promises); // 当前批次的所有绘制操作完成

        if (index < guids.length) {
          queueMicrotask(processBatch); // 使用更轻量的异步方法
        } else {
          resolve({ gridKeyValue, unvalidData, updateObjs }); // 全部批次处理完毕后，返回结果
        }
      }

      processBatch().catch((error) => {
        console.error("绘制网格时出错：", error);
        reject(error);
      });
    });
  } catch (error) {
    console.error("绘制网格时出错：", error);
    return null;
  }
};

//绘制指定标准层的墙
export const drawStdFlrWallData = (
  wallSectData,
  wallData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  wallColor,
  originHeight,
  originLevelB,
  stdFlrGridCData
) => {
  try {
    if (!gridKeyValue || !wallSectData || !wallData) return null;
    // Create a map for faster section data lookup by Guid
    const wallSectMap = new Map(wallSectData.map((item) => [item.Guid, item]));

    let updateObjs = []; // 记录需要在数据库更新的数据
    let unvalidData = []; //记录无效数据
    let guids = Object.keys(wallData);
    let batchSize = 100; // 批次大小
    let index = 0;

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = wallData[guid];
          if (!dataObj) {
            unvalidData.push(dataObj);
            continue;
          }

          if (!dataObj || !gridKeyValue || !gridKeyValue[dataObj.GridGuid]) {
            //找一遍是否是草图网格的墙,避免草图的墙被删除
            if (stdFlrGridCData && stdFlrGridCData[dataObj.GridGuid]) continue;
            //若找不到关联数据，将绘制数据清空
            else if (dataObj) {
              unvalidData.push(dataObj);
            }
            continue;
          }

          // Parse OtherData if available
          if (dataObj.OtherData) {
            if (
              typeof dataObj.OtherData === "string" &&
              dataObj.OtherData !== ""
            ) {
              dataObj.OtherData = JSON.parse(dataObj.OtherData);
            }
          }

          // Get corresponding section data
          let currSectData = wallSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将绘制数据清空
            unvalidData.push(dataObj);
            continue;
          }

          let drawing3DData = dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D)
            : null;
          let updateModel3dData = drawing3DData ? false : true;

          // 如果层高变化，则重新计算顶点标高
          if (
            originHeight &&
            originHeight !== currFlrHeight &&
            drawing3DData &&
            drawing3DData.points
          ) {
            originLevelB = 0; // 初始化标高
            let points = drawing3DData.points;

            drawing3DData.points = points.map((item, index) => {
              if (index % 3 === 2) {
                // 处理 Z 轴上的顶点
                if (item === originLevelB + dataObj.HDiffB) {
                  item = currFlrLevelB + dataObj.HDiffB;
                } else {
                  item = item + currFlrHeight - originHeight;
                }
              }
              return item;
            });

            updateModel3dData = true;
          }

          let updateDrawing = false;
          if (!updateModel3dData) {
            //判断截面尺寸是否修改
            let sectString = currSectData.B.toString();
            if (sectString != dataObj.CurrtSect) {
              updateModel3dData = true;
              updateDrawing = true;
            }
          }
          //当绑定的网格与草图有相同的节点guid重绘
          const updateDatabase =
            !drawing3DData ||
            updateDrawing ||
            updateModel3dData ||
            (stdFlrGridCData && stdFlrGridCData[dataObj.GridGuid]);
          // !(drawing3DData && !updateDrawing) || updateModel3dData;
          // 初始化墙体对象
          let rlWallObject = new rlWallData();
          rlWallObject.isWasmGeted = !updateDatabase;

          rlWallObject.initData({
            Guid: dataObj.Guid,
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: drawing3DData,
            points: drawing3DData ? drawing3DData.points : null,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat,
              Kind: currSectData.Kind,
              B: currSectData.B,
              H: currSectData.H,
              Guid: currSectData.Guid,
            },
            Ecc: dataObj.Ecc,
            HDiff1: dataObj.HDiff1,
            HDiff2: dataObj.HDiff2,
            HDiffB: dataObj.HDiffB,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            StdFlrGuid: dataObj.StdFlrGuid,
            LevelB: currFlrLevelB + dataObj.HDiffB,
            Height: currFlrHeight - dataObj.HDiffB,
            m_gridData: gridKeyValue[dataObj.GridGuid],
            Color: wallColor,
            LinkGuids: dataObj.LinkGuids?.split(","),
            CurrtSect: dataObj.CurrtSect,
            ModelNoLinkData:
              typeof dataObj.ModelNoLinkData === "string" &&
              dataObj.ModelNoLinkData !== ""
                ? JSON.parse(dataObj.ModelNoLinkData)
                : dataObj.ModelNoLinkData,
            maxWallBeamNo: dataObj.maxWallBeamNo ?? 0,
            maxWallColNo: dataObj.maxWallColNo ?? 0,
            m_RelationGuid: dataObj.RelationGuid,
          });

          rlWallObject.draw(); // 执行绘制操作
          promises.push(addEntityToDrawing(rlWallObject, true)); // 并发绘制

          if (updateDatabase) {
            updateObjs.push(rlWallObject.getDataBase()); // 收集需要更新的数据
          }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            queueMicrotask(processBatch); // 继续处理下一批数据
          } else {
            resolve({ updateObjs, unvalidData }); // 返回更新的数据
          }
        });
      }

      processBatch(); // 开始批次处理
    });
  } catch (error) {
    console.error("Error in drawing walls:", error);
    return null;
  }
};

//绘制指定标准层的隔墙
export const drawStdFlrPartitionWallData = (
  partitionWallSectData,
  partitionWallData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  originHeight,
  originLevelB,
  stdFlrGridCData
) => {
  try {
    if (!partitionWallSectData || !partitionWallData) return null;

    // Create a map for faster section data lookup by Guid
    const partitionWallSectMap = new Map(
      partitionWallSectData.map((item) => [item.Guid, item])
    );

    let updateObjs = []; // 记录需要在数据库更新的数据
    let unvalidData = []; // 记录需要删除的数据
    let guids = Object.keys(partitionWallData);
    let batchSize = 100; // 批次大小
    let index = 0;
    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = partitionWallData[guid];
          if (!dataObj) {
            unvalidData.push(dataObj);
            continue;
          }
          // 如果网格数据为空或者其他数据为空，则跳过,
          //当网格数据为空时,其他数据中存的就是隔墙的起点和终点数据
          if (
            !dataObj ||
            (dataObj.GridGuid &&
              (!gridKeyValue || !gridKeyValue[dataObj.GridGuid])) ||
            (!dataObj.GridGuid && !dataObj.OtherData)
          ) {
            //找一遍是否是草图网格的墙,避免草图的墙被删除
            if (stdFlrGridCData && stdFlrGridCData[dataObj.GridGuid]) continue;
            if (dataObj) {
              unvalidData.push(dataObj);
            }
            continue;
          }

          // Parse OtherData if available
          if (dataObj.OtherData) {
            if (
              typeof dataObj.OtherData === "string" &&
              dataObj.OtherData !== ""
            ) {
              dataObj.OtherData = JSON.parse(dataObj.OtherData);
            }
          }

          // Get corresponding section data
          let currSectData = partitionWallSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            unvalidData.push(dataObj);
            continue;
          }
          let drawing3DData = dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D)
            : null;
          let updateModel3dData = drawing3DData ? false : true;

          // 如果层高变化，则重新计算顶点标高
          if (
            originHeight &&
            dataObj.Height == originHeight &&
            originHeight !== currFlrHeight &&
            drawing3DData &&
            drawing3DData.points
          ) {
            originLevelB = 0; // 初始化标高
            let points = drawing3DData.points;

            drawing3DData.points = points.map((item, index) => {
              if (index % 3 === 2) {
                // 处理 Z 轴上的顶点
                if (item === originLevelB) {
                  item = currFlrLevelB;
                } else {
                  item = item + currFlrHeight - originHeight;
                }
              }
              return item;
            });
            updateModel3dData = true;
          }

          let updateDrawing = false;
          if (!updateModel3dData) {
            //判断截面尺寸是否修改
            let sectString = currSectData.B.toString();
            if (sectString != dataObj.CurrtSect) {
              updateModel3dData = true;
              updateDrawing = true;
            }
          }
          //当绑定的网格与草图有相同的节点guid重绘
          const updateDatabase =
            !drawing3DData ||
            updateDrawing ||
            updateModel3dData ||
            (stdFlrGridCData && stdFlrGridCData[dataObj.GridGuid]);

          // 初始化墙体对象
          let rlPartitionWallObject = new rlPartitionWallData();
          rlPartitionWallObject.isWasmGeted = !updateDatabase;
          let gridData = dataObj.GridGuid
            ? gridKeyValue[dataObj.GridGuid]
            : null;
          let partitionWallColor = getNonStructuralColor(dataObj.Mat);
          let spaceName = "";
          try {
            spaceName =
              dataObj.SpaceName && typeof dataObj.SpaceName !== "string"
                ? JSON.parse(dataObj.SpaceName)
                : "";
          } catch (error) {
            spaceName = "";
          }
          rlPartitionWallObject.initData({
            Guid: dataObj.Guid,
            index2dData: dataObj.Drawing_2D,
            index3dData: drawing3DData,
            points: drawing3DData ? drawing3DData.points : null,
            No_: dataObj.No_,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: dataObj.Mat,
              Kind: currSectData.Kind,
              B: currSectData.B,
              H: currSectData.H,
              Guid: currSectData.Guid,
            },
            partitionWallHeight:
              dataObj.Height == originHeight ? currFlrHeight : dataObj.Height, //dataObj.Height,
            Mat: dataObj.Mat,
            Ecc: dataObj.Ecc,
            Attribute: 0,
            StdFlrGuid: dataObj.StdFlrGuid,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            useFunctionNames: spaceName,
            m_gridData: gridData,
            Color: partitionWallColor,
            CurrtSect: dataObj.CurrtSect,
            OtherData: JSON.stringify(dataObj.OtherData),
            LinkGuids: dataObj.LinkGuids ? dataObj.LinkGuids?.split(",") : [],
            ModelNo: dataObj.ModelNo,
          });

          rlPartitionWallObject.draw(); // 执行绘制操作
          promises.push(addEntityToDrawing(rlPartitionWallObject, true)); // 并发绘制

          if (updateDatabase) {
            updateObjs.push(rlPartitionWallObject.getDataBase()); // 收集需要更新的数据
          }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            queueMicrotask(processBatch); // 继续处理下一批数据
          } else {
            resolve({ updateObjs, unvalidData }); // 返回更新的数据
          }
        });
      }

      processBatch(); // 开始批次处理
    });
  } catch (error) {
    console.error("Error in drawing PartitionWalls:", error);
    return null;
  }
};

//绘制指定标准层的梁
export const drawStdFlrBeamData = (
  beamSectData,
  beamData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  beamColor,
  subBeamColor,
  ringBeamColor,
  originHeight,
  originLevelB,
  stdFlrGridCData
) => {
  try {
    if (!gridKeyValue || !beamSectData || !beamData) return null;

    // Create a map for faster section data lookup by Guid
    const beamSectMap = new Map(beamSectData.map((item) => [item.Guid, item]));

    let updateObjs = []; // 记录需要在数据库更新的数据
    let unvalidData = []; //记录无效数据
    let guids = Object.keys(beamData);
    let batchSize = 100; // 批次大小
    let index = 0;

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = beamData[guid];
          if (!dataObj) {
            unvalidData.push(dataObj);
            continue;
          }

          if (!dataObj || !gridKeyValue || !gridKeyValue[dataObj.GridGuid]) {
            //找一遍是否是草图网格的墙,避免草图的墙被删除
            if (stdFlrGridCData && stdFlrGridCData[dataObj.GridGuid]) continue;
            //若找不到关联数据，将绘制数据清空
            else if (dataObj) {
              unvalidData.push(dataObj);
            }
            continue;
          }

          // Parse OtherData if available
          if (dataObj.OtherData) {
            if (
              typeof dataObj.OtherData === "string" &&
              dataObj.OtherData !== ""
            ) {
              dataObj.OtherData = JSON.parse(dataObj.OtherData);
            }
          }

          // Get corresponding section data
          let currSectData = beamSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          let drawing3DData = dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D)
            : null;
          let updateModel3dData = drawing3DData ? false : true;

          // 如果层高变化，则重新计算顶点标高
          if (
            originHeight &&
            originHeight !== currFlrHeight &&
            drawing3DData &&
            drawing3DData.points
          ) {
            let points = drawing3DData.points;
            drawing3DData.points = points.map((item, index) => {
              if (index % 3 === 2) {
                // 只处理 Z 轴上的顶点
                item = item + currFlrHeight - originHeight;
              }
              return item;
            });
            updateModel3dData = true;
          }

          let updateDrawing = false;
          if (!updateModel3dData) {
            //判断截面尺寸是否修改
            let splitdata = currSectData.ShapeVal.split(",");
            let sectString = splitdata.splice(1, splitdata.length - 3);
            sectString = sectString.join("*");
            if (sectString != dataObj.CurrtSect) {
              updateModel3dData = true;
              updateDrawing = true;
            }
          }
          //当绑定的网格与草图有相同的节点guid重绘
          const updateDatabase =
            !drawing3DData ||
            updateDrawing ||
            updateModel3dData ||
            (stdFlrGridCData && stdFlrGridCData[dataObj.GridGuid]);
          // !(drawing3DData && !updateDrawing) || updateModel3dData;
          // 初始化梁对象
          let rlBeamObject = new rlBeamData();
          rlBeamObject.isWasmGeted = !updateDatabase;

          rlBeamObject.initData({
            Guid: dataObj.Guid,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: drawing3DData,
            points: drawing3DData ? drawing3DData.points : null,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat,
              Kind: currSectData.Kind,
              ShapeVal: currSectData.ShapeVal,
              Guid: currSectData.Guid,
              IsRingBeamSeg: currSectData.IsRingBeamSeg,
            },
            StdFlrGuid: dataObj.StdFlrGuid,
            Ecc: dataObj.Ecc,
            HDiff1: dataObj.HDiff1,
            HDiff2: dataObj.HDiff2,
            Rotation: dataObj.Rotation,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            m_gridData: gridKeyValue[dataObj.GridGuid],
            Color: currSectData.IsRingBeamSeg
              ? ringBeamColor
              : dataObj.Attribute == 1
              ? beamColor
              : subBeamColor,
            LinkGuids: dataObj.LinkGuids?.split(","),
            CurrtSect: dataObj.CurrtSect,
            beamColor: beamColor,
            subBeamColor: subBeamColor,
            ringBeamColor: ringBeamColor,
            m_RelationGuid: dataObj.RelationGuid,
          });

          rlBeamObject.draw();
          promises.push(addEntityToDrawing(rlBeamObject, true)); // 并发绘制

          if (updateDatabase) {
            updateObjs.push(rlBeamObject.getDataBase());
          }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            queueMicrotask(processBatch); // 继续处理下一批数据
          } else {
            resolve({ updateObjs, unvalidData }); // 返回更新的数据
          }
        });
      }

      processBatch(); // 开始批次处理
    });
  } catch (error) {
    console.error("Error in drawing beams:", error);
    return null;
  }
};

//绘制指定标准层的柱
export const drawStdFlrColData = (
  colSectData,
  colData,
  jointKeyValue,
  currFlrHeight,
  currFlrLevelB,
  colColor,
  originHeight,
  originLevelB,
  stdFlrJointCData
) => {
  try {
    if (!jointKeyValue || !colSectData || !colData) return null;

    // Create a map for faster section lookup
    const colSectMap = new Map(colSectData.map((item) => [item.Guid, item]));

    let updateObjs = []; // 记录需要在数据库更新的数据
    let unvalidData = []; //记录无效数据
    let guids = Object.keys(colData);
    let index = 0;
    let batchSize = 100; // 批次大小

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = colData[guid];
          if (!dataObj) {
            unvalidData.push(dataObj);
            continue;
          }
          if (!dataObj || !jointKeyValue[dataObj.JtGuid]) {
            //找一遍是否是草图网格的墙,避免草图的墙被删除
            if (stdFlrJointCData && stdFlrJointCData[dataObj.JtGuid]) continue;
            //若找不到关联数据，将绘制数据清空
            if (dataObj) {
              unvalidData.push(dataObj);
            }
            continue;
          }

          let currSectData = colSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // Parse OtherData and Drawing_3D if available
          let otherData = {};
          if (
            typeof dataObj.OtherData === "string" &&
            dataObj.OtherData !== ""
          ) {
            otherData = JSON.parse(dataObj.OtherData);
          } else {
            otherData = dataObj.OtherData;
          }
          let drawing3DData = dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D)
            : null;
          let updateModel3dData = drawing3DData ? false : true;

          // 当层高变化时，重新计算顶点标高
          if (
            originHeight &&
            originHeight !== currFlrHeight &&
            drawing3DData &&
            drawing3DData.points
          ) {
            originLevelB = 0; // 初始化标高
            let points = drawing3DData.points;

            drawing3DData.points = points.map((item, index) => {
              if (index % 3 === 2) {
                // 处理 Z 轴上的顶点
                if (item === originLevelB + dataObj.HDiffB) {
                  item = currFlrLevelB + dataObj.HDiffB;
                } else {
                  item = item + currFlrHeight - originHeight + dataObj.HDiffB;
                }
              }
              return item;
            });
            updateModel3dData = true;
          }

          let updateDrawing = false;
          if (!updateModel3dData) {
            //判断截面尺寸是否修改
            let splitdata = currSectData.ShapeVal.split(",");
            let sectString = splitdata.splice(1, splitdata.length - 3);
            sectString = sectString.join("*");

            if (sectString != dataObj.CurrtSect) {
              updateModel3dData = true;
              updateDrawing = true;
            }
          }
          //stdFlrJointCData[dataObj.JtGuid];当绑定的节点与草图有相同的节点guid重绘
          const updateDatabase =
            !drawing3DData ||
            updateDrawing ||
            updateModel3dData ||
            (stdFlrJointCData && stdFlrJointCData[dataObj.JtGuid]);
          // !(drawing3DData && !updateDrawing) || updateModel3dData;

          // 初始化柱对象
          let rlColumnObject = new rlColumnData();
          rlColumnObject.isWasmGeted = !updateDatabase;
          rlColumnObject.initData({
            Guid: dataObj.Guid,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            OtherData: otherData,
            SectData: otherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: drawing3DData,
            points: drawing3DData ? drawing3DData.points : null,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat,
              Kind: currSectData.Kind,
              ShapeVal: currSectData.ShapeVal,
              Guid: currSectData.Guid,
            },
            StdFlrGuid: dataObj.StdFlrGuid,
            EccX: dataObj.EccX,
            EccY: dataObj.EccY,
            Rotation: dataObj.Rotation,
            HDiffB: dataObj.HDiffB,
            LevelB: currFlrLevelB,
            flrHeight: currFlrHeight,
            Height: currFlrHeight - dataObj.HDiffB,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            m_JointData: jointKeyValue[dataObj.JtGuid],
            Color: colColor,
            CurrtSect: dataObj.CurrtSect,
            m_RelationGuid: dataObj.RelationGuid,
          });

          rlColumnObject.draw();
          promises.push(addEntityToDrawing(rlColumnObject, true)); // 并发绘制

          if (updateDatabase) {
            updateObjs.push(rlColumnObject.getDataBase());
          }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            queueMicrotask(processBatch); // 继续处理下一批数据
          } else {
            resolve({ updateObjs, unvalidData }); // 返回更新的数据
          }
        });
      }

      processBatch(); // 开始批次处理
    });
  } catch (error) {
    console.error("Error drawing columns:", error);
    return null;
  }
};

//绘制指定标准层的板
export const drawStdFlrSlabData = (
  slabSectData,
  slabData,
  StdFlrParaData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  slabColor,
  originHeight
) => {
  try {
    if (!slabSectData || !slabData) return null;

    // Create a map for faster slab section lookup
    const slabSectMap = new Map(slabSectData.map((item) => [item.Guid, item]));

    // Default slab thickness
    let defaultThick = 100;
    if (StdFlrParaData) {
      let slabThickData = StdFlrParaData.find((item) => item.Kind === 1);
      if (slabThickData) {
        defaultThick = slabThickData.ParaVal;
      }
    }

    let updateObjs = [];
    let unvalidData = []; //记录无效数据
    let slabGuids = Object.keys(slabData);
    let batchSize = 100; // 每次处理的批次大小
    let index = 0;

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, slabGuids.length);

        for (; index < end; index++) {
          let guid = slabGuids[index];
          let dataObj = slabData[guid];
          if (!dataObj) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // 查找当前的截面数据
          let currSectData = slabSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // Parse OtherData and Drawing_3D if available
          let otherData = {};
          if (
            typeof dataObj.OtherData === "string" &&
            dataObj.OtherData !== ""
          ) {
            otherData = JSON.parse(dataObj.OtherData);
          } else {
            otherData = dataObj.OtherData;
          }
          let drawing3DData = dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D)
            : null;
          let updateModel3dData = drawing3DData ? false : true;

          // 层高变化时重新计算顶点标高
          if (
            originHeight &&
            originHeight !== currFlrHeight &&
            drawing3DData &&
            drawing3DData.points
          ) {
            let points = drawing3DData.points;
            drawing3DData.points = points.map((item, index) => {
              if (index % 3 === 2) {
                // 只处理 Z 轴上的顶点
                item = item + currFlrHeight - originHeight;
              }
              return item;
            });
            updateModel3dData = true;
          }

          let updateDrawing = false;
          if (!updateModel3dData) {
            //判断截面尺寸是否修改
            let splitdata = currSectData.Thickness.toString();

            if (splitdata != dataObj.CurrtSect) {
              updateModel3dData = true;
              updateDrawing = true;
            }
          }

          // 处理网格数据
          let gridsObjs = [];
          if (dataObj.GridsGuid) {
            let gridsGuidArray = dataObj.GridsGuid.split(",");
            gridsGuidArray = gridsGuidArray.filter((item) => item != "");
            gridsObjs = gridsGuidArray
              .map((guid) => gridKeyValue[guid])
              .filter(Boolean);

            if (gridsGuidArray.length != gridsObjs.length) {
              unvalidData.push(dataObj);
              continue;
            }
          }
          if (gridsObjs.length == 0) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          if (gridsObjs.length) {
            const updateDatabase =
              !drawing3DData || updateDrawing || updateModel3dData;

            // if (
            //   updateDatabase &&
            //   gridsObjs.filter(
            //     (item) =>
            //       item.m_centerJoint ||
            //       (item.m_Axis && item.m_Axis.IsMainAxis == -1)
            //   ).length
            // ) {
            //   //若需要更新,重新计算存在圆弧网格的楼板顶点数据
            //   let VertexX = dataObj.VertexX.split(",");
            //   let VertexY = dataObj.VertexY.split(",");
            //   let vertexData = []; //记录顶点数据
            //   for (let i = 0; i < VertexX.length; i++) {
            //     vertexData.push(new THREE.Vector3(VertexX[i], VertexY[i], 0));
            //   }

            //   let updateVertex = false;
            //   for (let i = 0; i < gridsObjs.length; i++) {
            //     let grid = gridsObjs[i];
            //     if (
            //       grid.m_centerJoint ||
            //       (grid.m_Axis && grid.m_Axis.IsMainAxis == -1)
            //     ) {
            //       let arcStart = new THREE.Vector3(...grid.m_stJoint.m_pt);
            //       //对x,y进行四舍五入,保留两位小数
            //       arcStart.x = Math.round(arcStart.x * 100) / 100;
            //       arcStart.y = Math.round(arcStart.y * 100) / 100;
            //       let arcEnd = new THREE.Vector3(...grid.m_edJoint.m_pt);
            //       //对x,y进行四舍五入,保留两位小数
            //       arcEnd.x = Math.round(arcEnd.x * 100) / 100;
            //       arcEnd.y = Math.round(arcEnd.y * 100) / 100;
            //       //获取顶点数据中的起始点和结束点
            //       let startIndex = vertexData.findIndex(
            //         (item) => item.x == arcStart.x && item.y == arcStart.y
            //       );
            //       let endIndex = vertexData.findIndex(
            //         (item) => item.x == arcEnd.x && item.y == arcEnd.y
            //       );

            //       if (startIndex == -1 || endIndex == -1) continue; //如果起始点和结束点不存在，则跳过
            //       if (Math.abs(startIndex - endIndex) > 2) continue; //如果起始点和结束点之间的距离大于2，则跳过
            //       if (startIndex > endIndex) {
            //         [startIndex, endIndex] = [endIndex, startIndex];
            //       }

            //       let points = getArcPoints(
            //         arcStart,
            //         arcEnd,
            //         new THREE.Vector3(...grid.m_Axis.m_stJoint.m_pt),
            //         grid.mcDbGrid.radius
            //       ).reverse();

            //       //在startIndex和endIndex之间插入points，且剔除原startIndex和endIndex位置的数据
            //       VertexX.splice(
            //         startIndex,
            //         endIndex - startIndex + 1,
            //         ...points.map((item) => item.x)
            //       );
            //       VertexY.splice(
            //         startIndex,
            //         endIndex - startIndex + 1,
            //         ...points.map((item) => item.y)
            //       );

            //       updateVertex = true;
            //     }
            //   }
            //   if (updateVertex) {
            //     //删除第一个点
            //     VertexX.shift();
            //     VertexY.shift();
            //     dataObj.VertexX = VertexX.join(",");
            //     dataObj.VertexY = VertexY.join(",");
            //   }
            // }

            let rlSlabObject = new rlSlabData();
            rlSlabObject.isWasmGeted = !updateDatabase;

            rlSlabObject.initData({
              Guid: dataObj.Guid,
              No_: dataObj.No_,
              ModelNo: dataObj.ModelNo,
              OtherData: otherData,
              SectData: otherData.SectData,
              index2dData: dataObj.Drawing_2D,
              index3dData: drawing3DData,
              points: drawing3DData ? drawing3DData.points : null,
              m_sectParamData: {
                Kind: currSectData.Kind,
                Mat: currSectData.Mat,
                Thickness: currSectData.Thickness,
                Guid: currSectData.Guid,
              },
              StdFlrGuid: dataObj.StdFlrGuid,
              Thickness: dataObj.Thickness || defaultThick,
              RoomlsHole: dataObj.RoomlsHole,
              VertexX: dataObj.VertexX,
              VertexY: dataObj.VertexY,
              VertexZ: dataObj.VertexZ,
              cc: dataObj.cc ? dataObj.cc : 0,
              ParaVal: defaultThick,
              LevelB: currFlrLevelB,
              Height: currFlrHeight,
              Strength: dataObj.Strength,
              StrengthOther: dataObj.StrengthOther,
              Attribute: dataObj.Attribute,
              gridsObjs: gridsObjs,
              GridsGuid: dataObj.GridsGuid,
              RoomIsHole: dataObj.RoomIsHole,
              Color: slabColor,
              CurrtSect: dataObj.CurrtSect,
              m_RelationGuid: dataObj.RelationGuid,
            });

            rlSlabObject.draw();
            promises.push(addEntityToDrawing(rlSlabObject, true));

            if (updateDatabase) {
              updateObjs.push(rlSlabObject.getDataBase());
            }
          }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < slabGuids.length) {
            queueMicrotask(processBatch); // 处理下一批
          } else {
            resolve({ updateObjs, unvalidData }); // 所有处理完成后返回更新数据
          }
        });
      }

      processBatch(); // 启动批处理
    });
  } catch (error) {
    console.error("Error drawing slabs:", error);
    return null;
  }
};

//绘制指定标准层的悬挑板
export const drawStdFlrCantiSlabData = (
  cantiSlabSectData,
  cantiSlabData,
  StdFlrParaData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  cantiSlabColor,
  originHeight
) => {
  try {
    if (!cantiSlabSectData || !cantiSlabData) return null;

    // Create a map for faster slab section lookup
    const cantiSlabSectMap = new Map(
      cantiSlabSectData.map((item) => [item.Guid, item])
    );

    // Default slab thickness
    let defaultThick = 100;
    if (StdFlrParaData) {
      let slabThickData = StdFlrParaData.find((item) => item.Kind === 1);
      if (slabThickData) {
        defaultThick = slabThickData.ParaVal;
      }
    }

    let updateObjs = [];
    let unvalidData = []; //记录无效数据
    let slabGuids = Object.keys(cantiSlabData);
    let batchSize = 100; // 每次处理的批次大小
    let index = 0;

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, slabGuids.length);

        for (; index < end; index++) {
          let guid = slabGuids[index];
          let dataObj = cantiSlabData[guid];
          if (!dataObj) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }
          // 查找当前的截面数据
          let currSectData = cantiSlabSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }
          let tempCrrSectData = {
            Width: currSectData.Length,
            Length: currSectData.Width,
            Kind: currSectData.Kind,
            Thick: currSectData.Thick,
            No_: currSectData.No_,
            Guid: currSectData.Guid,
          };
          if (!dataObj || !gridKeyValue || !gridKeyValue[dataObj.GridGuid]) {
            //找一遍是否是草图网格的墙,避免草图的墙被删除
            // if (stdFlrGridCData[dataObj.GridGuid]) continue;
            //若找不到关联数据，将数据清空
            if (dataObj) {
              unvalidData.push(dataObj);
            }
            continue;
          }
          // Parse OtherData and Drawing_3D if available
          let otherData = {};
          if (
            typeof dataObj.OtherData === "string" &&
            dataObj.OtherData !== ""
          ) {
            otherData = JSON.parse(dataObj.OtherData);
          } else {
            otherData = dataObj.OtherData;
          }
          let drawing3DData = dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D)
            : null;
          let updateModel3dData = drawing3DData ? false : true;

          // 层高变化时重新计算顶点标高
          if (
            originHeight &&
            originHeight !== currFlrHeight &&
            drawing3DData &&
            drawing3DData.points
          ) {
            let points = drawing3DData.points;
            drawing3DData.points = points.map((item, index) => {
              if (index % 3 === 2) {
                // 只处理 Z 轴上的顶点
                item = item + currFlrHeight - originHeight;
              }
              return item;
            });
            updateModel3dData = true;
          }

          let updateDrawing = false;
          if (!updateModel3dData) {
            //判断截面尺寸是否修改
            let splitdata = tempCrrSectData.Thick.toString();

            if (splitdata != dataObj.CurrtSect) {
              updateModel3dData = true;
              updateDrawing = true;
            }
          }

          let points2dData = [];
          if (dataObj.Drawing_2D != null) {
            let points2d = dataObj.Drawing_2D.split(",");
            if (points2d.length >= 3) {
              for (let i = 0; i < points2d.length; i += 3) {
                points2dData.push(
                  new McGePoint3d(points2d[i], points2d[i + 1], 0)
                );
              }
            }
          }
          if (points2dData.length == 0) {
            let gridStart = new McGePoint3d(
              ...gridKeyValue[dataObj.GridGuid].m_stJoint.m_pt
            );
            let gridEnd = new McGePoint3d(
              ...gridKeyValue[dataObj.GridGuid].m_edJoint.m_pt
            );
            let { leftPt, rightPt, oneVec, twoVec } =
              calculate_cantiSlab_dr_params(gridKeyValue[dataObj.GridGuid]);
            let vec = null;
            let stPt = null;
            let vecY = dataObj.dr == 1 ? oneVec : twoVec;
            if (leftPt.distanceTo(gridStart) < 1) {
              stPt = gridStart;
              vec = new THREE.Vector3()
                .subVectors(rightPt, gridStart)
                .normalize();
            } else {
              stPt = gridEnd;
              vec = new THREE.Vector3()
                .subVectors(leftPt, gridStart)
                .normalize();
            }
            let width =
              tempCrrSectData.Width == 0
                ? gridStart.distanceTo(gridEnd)
                : tempCrrSectData.Width;
            let moveDist = Math.abs(dataObj.ec);
            if (moveDist == 0 && tempCrrSectData.Width != 0) {
              moveDist = gridStart.distanceTo(gridEnd) / 2 - width / 2;
            }
            points2dData.push(MovePt(stPt, vec, moveDist));
            points2dData.push(
              MovePt(points2dData[0], vecY, tempCrrSectData.Length)
            );
            points2dData.push(MovePt(points2dData[1], vec, width));
            points2dData.push(MovePt(points2dData[0], vec, width));
          }

          const updateDatabase =
            !drawing3DData || updateDrawing || updateModel3dData;

          let rlCantiSlabObject = new rlCantiSlabData();
          rlCantiSlabObject.isWasmGeted = !updateDatabase;

          rlCantiSlabObject.initData({
            Guid: dataObj.Guid,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            OtherData: otherData,
            SectData: otherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: drawing3DData,
            cantiSlabPoints: points2dData,
            m_sectParamData: tempCrrSectData,
            StdFlrGuid: dataObj.StdFlrGuid,
            Thickness:
              dataObj.Thickness == 0 ? defaultThick : dataObj.Thickness,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Attribute: dataObj.Attribute,
            Color: cantiSlabColor,
            CurrtSect: dataObj.CurrtSect,
            m_gridData: gridKeyValue[dataObj.GridGuid],
            m_ec: dataObj.ec,
            m_dr: dataObj.dr,
            m_ez: dataObj.ez,
          });

          rlCantiSlabObject.draw();
          promises.push(addEntityToDrawing(rlCantiSlabObject, true));

          if (updateDatabase) {
            updateObjs.push(rlCantiSlabObject.getDataBase());
          }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < slabGuids.length) {
            queueMicrotask(processBatch); // 处理下一批
          } else {
            resolve({ updateObjs, unvalidData }); // 所有处理完成后返回更新数据
          }
        });
      }

      processBatch(); // 启动批处理
    });
  } catch (error) {
    console.error("Error drawing slabs:", error);
    return null;
  }
};

//绘制指定标准层的板洞
export const drawStdFlrSlabHoleData = async (
  slabSectData,
  salbData,
  jointKeyValue,
  currFlrHeight,
  currFlrLevelB,
  originHeight,
  slabHoleColor
) => {
  try {
    if (!jointKeyValue || !slabSectData || !salbData) return null;

    // Create a Map for faster section lookup
    const slabSectMap = new Map(slabSectData.map((item) => [item.Guid, item]));

    let updateObjs = []; // Store the objects to be updated
    let unvalidData = []; //记录无效数据·
    let slabGuids = Object.keys(salbData);
    let batchSize = 100; // Each batch size
    let index = 0;

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, slabGuids.length);

        for (; index < end; index++) {
          let guid = slabGuids[index];
          let dataObj = salbData[guid];
          if (
            !dataObj ||
            !dataObj.SlabGuid ||
            !dataObj.JtGuid ||
            !jointKeyValue[dataObj.JtGuid]
          ) {
            //若找不到关联数据，将数据清空
            if (dataObj) {
              unvalidData.push(dataObj);
            }
            continue;
          }

          // Get corresponding section data
          const currSectData = slabSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // Retrieve slab object data
          let rlSlabObj = getEntityData({
            Guid: dataObj.SlabGuid,
            classTypeName: "rlSlab",
          });
          if (!rlSlabObj) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // Parse OtherData and Drawing_3D
          if (
            typeof dataObj.OtherData === "string" &&
            dataObj.OtherData !== ""
          ) {
            dataObj.OtherData = JSON.parse(dataObj.OtherData);
          } else {
            dataObj.OtherData = dataObj.OtherData;
          }
          let drawing3DData = dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D)
            : null;
          let updateModel3dData = drawing3DData ? false : true;

          // Adjust the height of points if the floor height has changed
          if (originHeight && originHeight !== currFlrHeight && drawing3DData) {
            drawing3DData.points = drawing3DData.points.map((point, idx) => {
              return idx % 3 === 2
                ? point + Number(currFlrHeight) - Number(originHeight)
                : point;
            });
            updateModel3dData = true;
          }

          let updateDrawing = false;
          if (!updateModel3dData) {
            //判断截面尺寸是否修改
            let splitdata = currSectData.ShapeVal.split(",");
            let sectString = splitdata.splice(1, splitdata.length - 3);
            sectString = sectString.join("*") + "*" + rlSlabObj.Thickness;
            if (splitdata != dataObj.CurrtSect) {
              updateModel3dData = true;
              updateDrawing = true;
            }
          }

          const updateDatabase =
            !drawing3DData || updateDrawing || updateModel3dData;
          // !(drawing3DData && !updateDrawing) || updateModel3dData;
          const slabThick = rlSlabObj.Thickness;

          // Initialize and draw slab hole object
          const rlSlabHoleObject = new rlSlabHoleData();
          rlSlabHoleObject.isWasmGeted = !updateDatabase;
          rlSlabHoleObject.initData({
            Guid: dataObj.Guid,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            OtherData: dataObj.OtherData,
            // SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: drawing3DData,
            points: drawing3DData ? drawing3DData.points : null,
            m_sectParamData: {
              ShapeVal: currSectData.ShapeVal,
              Kind: currSectData.Kind,
              Guid: currSectData.Guid,
            },
            Rotation: dataObj.Rotation,
            m_JointData: jointKeyValue[dataObj.JtGuid],
            m_SlabData: rlSlabObj,
            Height: currFlrHeight,
            EccX: dataObj.EccX,
            EccY: dataObj.EccY,
            slabThickness: slabThick,
            Attribute: dataObj.Attribute,
            StdFlrGuid: dataObj.StdFlrGuid,
            LevelB: currFlrLevelB,
            Color: [],
            CurrtSect: dataObj.CurrtSect,
          });

          rlSlabHoleObject.draw();
          promises.push(addEntityToDrawing(rlSlabHoleObject, true));

          if (updateDatabase) {
            updateObjs.push(rlSlabHoleObject.getDataBase());
          }
        }

        // Process next batch after the current one finishes
        Promise.all(promises).then(() => {
          if (index < slabGuids.length) {
            queueMicrotask(processBatch);
          } else {
            resolve({ updateObjs, unvalidData });
          }
        });
      }

      processBatch(); // Start processing the first batch
    });
  } catch (error) {
    console.error("Error drawing slab holes:", error);
    return null;
  }
};

//绘制指定标准层的圈梁
export const drawStdFlrRingBeamData = async (
  beamSectData,
  beamData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  ringBeamColor,
  originHeight,
  originLevelB
) => {
  try {
    // 检查必要的数据是否存在
    if (!gridKeyValue || !beamSectData || !beamData) return null;

    // 创建截面数据的快速查找 Map
    const beamSectMap = new Map(beamSectData.map((item) => [item.Guid, item]));

    let updateObjs = []; // 记录需要更新的对象
    let unvalidData = []; //记录无效数据
    let beamGuids = Object.keys(beamData);
    let batchSize = 100; // 批处理大小
    let index = 0;

    // 批量处理的主逻辑
    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, beamGuids.length);

        for (; index < end; index++) {
          let guid = beamGuids[index];
          let dataObj = beamData[guid];

          // 跳过无效数据
          if (!dataObj || !gridKeyValue || !gridKeyValue[dataObj.GridGuid]) {
            //若找不到关联数据，将数据清空
            if (dataObj) {
              unvalidData.push(dataObj);
            }
            continue;
          }

          // 如果存在 OtherData，则解析它
          let otherData = null;
          if (
            typeof dataObj.OtherData === "string" &&
            dataObj.OtherData !== ""
          ) {
            otherData = JSON.parse(dataObj.OtherData);
          } else {
            otherData = dataObj.OtherData;
          }

          // 获取当前截面数据
          const currSectData = beamSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // 解析 3D 绘图数据
          let drawing3DData = dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D)
            : null;
          let updateModel3dData = drawing3DData ? false : true;

          // 如果楼层高度发生变化，更新顶点 Z 轴坐标
          if (originHeight && originHeight !== currFlrHeight && drawing3DData) {
            drawing3DData.points = drawing3DData.points.map((point, idx) =>
              idx % 3 === 2
                ? point + Number(currFlrHeight) - Number(originHeight)
                : point
            );
            updateModel3dData = true;
          }

          let updateDrawing = false;
          if (!updateModel3dData) {
            //判断截面尺寸是否修改
            let splitdata = currSectData.ShapeVal.split(",");
            let sectString = splitdata.splice(1, splitdata.length - 3);
            sectString = sectString.join("*");
            if (sectString != dataObj.CurrtSect) {
              updateModel3dData = true;
              updateDrawing = true;
            }
          }
          const updateDatabase =
            !drawing3DData || updateDrawing || updateModel3dData;
          // !(drawing3DData && !updateDrawing) || updateModel3dData;
          // 初始化并绘制圈梁对象
          const rlBeamObject = new rlRingBeamData();
          rlBeamObject.isWasmGeted = !updateDatabase;
          rlBeamObject.initData({
            Guid: dataObj.Guid,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            OtherData: otherData,
            SectData: otherData ? otherData.SectData : null,
            index2dData: dataObj.Drawing_2D,
            index3dData: drawing3DData,
            points: drawing3DData ? drawing3DData.points : null,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat,
              Kind: currSectData.Kind,
              ShapeVal: currSectData.ShapeVal,
              Guid: currSectData.Guid,
            },
            StdFlrGuid: dataObj.StdFlrGuid,
            Ecc: dataObj.Ecc,
            HDiff1: dataObj.HDiff1,
            HDiff2: dataObj.HDiff2,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            m_gridData: gridKeyValue[dataObj.GridGuid],
            Color: ringBeamColor,
            LinkGuids: dataObj.LinkGuids?.split(","),
            CurrtSect: dataObj.CurrtSect,
          });

          // 绘制圈梁对象
          rlBeamObject.draw();
          promises.push(addEntityToDrawing(rlBeamObject, true));

          // 如果模型 3D 数据需要更新，将其添加到更新列表
          if (updateDatabase) {
            updateObjs.push(rlBeamObject.getDataBase());
          }
        }

        // 当前批次处理完成后继续下一批
        Promise.all(promises).then(() => {
          if (index < beamGuids.length) {
            queueMicrotask(processBatch); // 使用微任务继续处理下一批
          } else {
            resolve({ updateObjs, unvalidData }); // 全部处理完成后返回更新数据
          }
        });
      }

      processBatch(); // 启动批量处理
    });
  } catch (error) {
    console.error("Error drawing ring beams:", error);
    return null;
  }
};

//绘制指定标准层的次梁
export const drawStdFlrSubBeamData = async (
  beamSectData,
  beamData,
  currFlrHeight,
  currFlrLevelB,
  subBeamColor,
  originHeight
) => {
  try {
    if (!beamSectData || !beamData) return null;

    // 将截面数据转成 Map 结构，便于快速查找
    const beamSectMap = new Map(beamSectData.map((item) => [item.Guid, item]));

    let updateObjs = []; // 记录需要更新的对象
    let unvalidData = []; //记录无效数据
    const beamGuids = Object.keys(beamData);
    const batchSize = 100; // 批处理的大小
    let index = 0;

    // 批量处理的逻辑
    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        const end = Math.min(index + batchSize, beamGuids.length);

        for (; index < end; index++) {
          let guid = beamGuids[index];
          let dataObj = beamData[guid];

          // 跳过无效数据
          if (!dataObj) {
            continue;
          }

          // 如果存在 OtherData，则解析它
          let otherData = null;
          if (
            typeof dataObj.OtherData === "string" &&
            dataObj.OtherData !== ""
          ) {
            otherData = JSON.parse(dataObj.OtherData);
          } else {
            otherData = dataObj.OtherData;
          }

          // 获取当前的截面数据
          const currSectData = beamSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // 解析 3D 绘图数据
          const drawing3DData = dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D)
            : null;
          let updateModel3dData = drawing3DData ? false : true;

          // 如果楼层高度变化，则更新顶点 Z 轴坐标
          if (originHeight && originHeight !== currFlrHeight && drawing3DData) {
            drawing3DData.points = drawing3DData.points.map((point, idx) =>
              idx % 3 === 2
                ? point + Number(currFlrHeight) - Number(originHeight)
                : point
            );
            updateModel3dData = true;
          }

          let updateDrawing = false;
          if (!updateModel3dData) {
            //判断截面尺寸是否修改
            let splitdata = currSectData.ShapeVal.split(",");
            let sectString = splitdata.splice(1, splitdata.length - 3);
            sectString = sectString.join("*");
            if (sectString != dataObj.CurrtSect) {
              updateModel3dData = true;
              updateDrawing = true;
            }
          }
          const updateDatabase =
            !drawing3DData || updateDrawing || updateModel3dData;
          // !(drawing3DData && !updateDrawing) || updateModel3dData;
          // 初始化并绘制次梁对象
          const rlBeamObject = new rlSubBeamData();
          rlBeamObject.isWasmGeted = !updateDatabase;
          rlBeamObject.initData({
            Guid: dataObj.Guid,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            OtherData: otherData,
            SectData: otherData ? otherData.SectData : null,
            index2dData: dataObj.Drawing_2D,
            index3dData: drawing3DData,
            points: drawing3DData ? drawing3DData.points : null,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat,
              Kind: currSectData.Kind,
              ShapeVal: currSectData.ShapeVal,
              Guid: currSectData.Guid,
            },
            StdFlrGuid: dataObj.StdFlrGuid,
            m_gridData1ID: dataObj.gridData1ID,
            m_gridData2ID: dataObj.gridData2ID,
            m_X1: dataObj.X1,
            m_Y1: dataObj.Y1,
            m_Z1: dataObj.Z1,
            m_X2: dataObj.X2,
            m_Y2: dataObj.Y2,
            m_Z2: dataObj.Z2,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            Color: subBeamColor,
            CurrtSect: dataObj.CurrtSect,
          });

          // 绘制次梁对象
          rlBeamObject.draw();
          promises.push(addEntityToDrawing(rlBeamObject, true));

          // 如果需要更新模型 3D 数据，则加入更新队列
          if (updateDatabase) {
            updateObjs.push(rlBeamObject.getDataBase());
          }
        }

        // 当前批次处理完成后继续处理下一批
        Promise.all(promises).then(() => {
          if (index < beamGuids.length) {
            queueMicrotask(processBatch); // 继续处理下一批
          } else {
            resolve({ updateObjs, unvalidData }); // 全部处理完成后返回更新数据
          }
        });
      }

      processBatch(); // 启动批量处理
    });
  } catch (error) {
    console.error("Error drawing sub beams:", error);
    return null;
  }
};

//绘制指定标准层的墙洞
export const drawStdFlrWallHoleData = async (
  wallSectData,
  wallData,
  partitionWallSegData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  wallHoleColor,
  originHeight,
  stdFlrGridCData
) => {
  try {
    if (!gridKeyValue || !wallSectData || !wallData) return null;

    // 将截面数据转换为 Map 结构，方便快速查找
    const wallSectMap = new Map(wallSectData.map((item) => [item.Guid, item]));

    let updateObjs = []; // 记录需要更新的对象
    let unvalidData = []; //记录无效数据
    const wallGuids = Object.keys(wallData);
    const batchSize = 100; // 批处理大小

    let index = 0;

    // 批量处理的逻辑
    return new Promise((resolve) => {
      async function processBatch() {
        let promises = [];
        const end = Math.min(index + batchSize, wallGuids.length);

        for (; index < end; index++) {
          let guid = wallGuids[index];
          let dataObj = wallData[guid];
          // 跳过无效数据
          if (!dataObj || !gridKeyValue || !gridKeyValue[dataObj.GridGuid]) {
            if (
              partitionWallSegData &&
              !partitionWallSegData[dataObj.GridGuid]
            ) {
              //若找不到关联数据，将绘制数据清空
              if (dataObj) {
                unvalidData.push(dataObj);
              }
              continue;
            }
          }
          if (gridKeyValue[dataObj.GridGuid]) {
            const gridData = gridKeyValue[dataObj.GridGuid];

            if (!gridData.m_wallId) {
              //若找不到关联数据，将绘制数据清空
              unvalidData.push(dataObj);
              continue;
            }

            // 解析 OtherData
            let otherData = {};
            if (
              typeof dataObj.OtherData === "string" &&
              dataObj.OtherData !== ""
            ) {
              otherData = JSON.parse(dataObj.OtherData);
            } else {
              otherData = dataObj.OtherData;
            }

            // 获取截面数据
            const currSectData = wallSectMap.get(dataObj.SectGuid);

            if (!currSectData) {
              //若找不到关联数据，将数据清空
              unvalidData.push(dataObj);
              continue;
            }

            // 获取墙体厚度和偏心率
            const rlWallObj = getEntityData({
              Guid: gridData.m_wallId,
              classTypeName: "rlWallSeg",
            });

            if (!rlWallObj) continue;

            const wallThick = rlWallObj.m_sectParamData.B || 0;
            const wallEcc = rlWallObj.Ecc || 0;

            if (wallThick > 0) {
              let drawing3DData = dataObj.Drawing_3D
                ? JSON.parse(dataObj.Drawing_3D)
                : null;
              let updateModel3dData = drawing3DData ? false : true;

              // 如果层高变化，重新计算顶点的 Z 坐标
              if (
                originHeight &&
                originHeight !== currFlrHeight &&
                drawing3DData
              ) {
                drawing3DData.points = drawing3DData.points.map(
                  (point, index) =>
                    index % 3 === 2
                      ? point + Number(currFlrHeight) - Number(originHeight)
                      : point
                );
                updateModel3dData = true;
              }

              let updateDrawing = false;
              if (!updateModel3dData) {
                //判断截面尺寸是否修改,考虑墙厚变化
                let sectString =
                  currSectData.B + "*" + currSectData.H + "*" + wallThick;
                if (sectString != dataObj.CurrtSect) {
                  updateModel3dData = true;
                  updateDrawing = true;
                }
              }
              const updateDatabase =
                !drawing3DData ||
                updateDrawing ||
                updateModel3dData ||
                (stdFlrGridCData && stdFlrGridCData[gridData.Guid]);
              let color = getNonStructuralColor(dataObj.Mat);
              if (!dataObj.Mat || dataObj.Mat == -1) {
                color = { r: 255, g: 255, b: 255 };
              }
              // !(drawing3DData && !updateDrawing) || updateModel3dData;
              // 初始化并绘制墙洞对象
              const rlWallObject = new rlWallHoleData();
              rlWallObject.isWasmGeted = !updateDatabase;
              rlWallObject.initData({
                Guid: dataObj.Guid,
                No_: dataObj.No_,
                ModelNo: dataObj.ModelNo,
                OtherData: otherData,
                SectData: otherData ? otherData.SectData : null,
                index2dData: dataObj.Drawing_2D,
                index3dData: drawing3DData,
                points: drawing3DData ? drawing3DData.points : null,
                m_sectParamData: {
                  Name: currSectData.Name,
                  Mat: currSectData.Mat,
                  Kind: currSectData.Kind,
                  B: currSectData.B,
                  H: currSectData.H,
                  Guid: currSectData.Guid,
                },
                m_wallThick: wallThick,
                m_wallEcc: wallEcc,
                Ecc: dataObj.Ecc,
                HDiff: dataObj.HDiff,
                Strength: dataObj.Strength,
                StrengthOther: dataObj.StrengthOther,
                Attribute: dataObj.Attribute,
                StdFlrGuid: dataObj.StdFlrGuid,
                LevelB: currFlrLevelB,
                Height: currFlrHeight,
                m_gridData: gridData,
                Color: color,
                LinkGuids: dataObj.LinkGuids?.split(","),
                CurrtSect: dataObj.CurrtSect,
                m_RelationGuid: dataObj.RelationGuid,
                doorsWindowsType: dataObj.DoorsWindowsType,
                Mat: dataObj.Mat,
                IsPartitionWall: 0,
              });
              // 绘制墙洞对象
              rlWallObject.draw();
              promises.push(addEntityToDrawing(rlWallObject, true));
              rlWallObj.m_HoleId = dataObj.Guid;
              rlWallObj.drawBreakWall();
              // 如果需要更新 3D 数据，则加入更新队列
              if (updateDatabase) {
                updateObjs.push(rlWallObject.getDataBase());
              }
            }
          } else if (partitionWallSegData[dataObj.GridGuid]) {
            const partitionWallData = partitionWallSegData[dataObj.GridGuid];
            // 解析 OtherData
            let otherData = {};
            if (
              typeof dataObj.OtherData === "string" &&
              dataObj.OtherData !== ""
            ) {
              otherData = JSON.parse(dataObj.OtherData);
            } else {
              otherData = dataObj.OtherData;
            }

            // 获取截面数据
            const currSectData = wallSectMap.get(dataObj.SectGuid);

            if (!currSectData) {
              //若找不到关联数据，将数据清空
              unvalidData.push(dataObj);
              continue;
            }

            // 获取墙体厚度和偏心率
            const rlWallObj = getEntityData({
              Guid: partitionWallData.Guid,
              classTypeName: "rlPartitionWallSeg",
            });

            if (!rlWallObj) continue;

            const wallThick = rlWallObj.m_sectParamData.B || 0;
            const wallEcc = rlWallObj.Ecc || 0;

            if (wallThick > 0) {
              let drawing3DData = dataObj.Drawing_3D
                ? JSON.parse(dataObj.Drawing_3D)
                : null;
              let updateModel3dData = drawing3DData ? false : true;

              // 如果层高变化，重新计算顶点的 Z 坐标
              if (
                originHeight &&
                originHeight !== currFlrHeight &&
                drawing3DData
              ) {
                drawing3DData.points = drawing3DData.points.map(
                  (point, index) =>
                    index % 3 === 2
                      ? point + Number(currFlrHeight) - Number(originHeight)
                      : point
                );
                updateModel3dData = true;
              }

              let updateDrawing = false;
              if (!updateModel3dData) {
                //判断截面尺寸是否修改,考虑墙厚变化
                let sectString =
                  currSectData.B + "*" + currSectData.H + "*" + wallThick;
                if (sectString != dataObj.CurrtSect) {
                  updateModel3dData = true;
                  updateDrawing = true;
                }
              }
              const updateDatabase =
                !drawing3DData || updateDrawing || updateModel3dData;
              let color = getNonStructuralColor(dataObj.Mat);
              if (!dataObj.Mat || dataObj.Mat == -1) {
                color = { r: 255, g: 255, b: 255 };
              }
              // !(drawing3DData && !updateDrawing) || updateModel3dData;
              // 初始化并绘制墙洞对象
              const rlWallObject = new rlWallHoleData();
              rlWallObject.isWasmGeted = !updateDatabase;
              rlWallObject.initData({
                Guid: dataObj.Guid,
                No_: dataObj.No_,
                ModelNo: dataObj.ModelNo,
                OtherData: otherData,
                SectData: otherData ? otherData.SectData : null,
                index2dData: dataObj.Drawing_2D,
                index3dData: drawing3DData,
                points: drawing3DData ? drawing3DData.points : null,
                m_sectParamData: {
                  Name: currSectData.Name,
                  Mat: currSectData.Mat,
                  Kind: currSectData.Kind,
                  B: currSectData.B,
                  H: currSectData.H,
                  Guid: currSectData.Guid,
                },
                m_wallThick: wallThick,
                m_wallEcc: wallEcc,
                Ecc: dataObj.Ecc,
                HDiff: dataObj.HDiff,
                Strength: dataObj.Strength,
                StrengthOther: dataObj.StrengthOther,
                Attribute: dataObj.Attribute,
                StdFlrGuid: dataObj.StdFlrGuid,
                LevelB: currFlrLevelB,
                Height: currFlrHeight,
                m_gridData: rlWallObj,
                Color: color,
                LinkGuids: dataObj.LinkGuids?.split(","),
                CurrtSect: dataObj.CurrtSect,
                m_RelationGuid: dataObj.RelationGuid,
                doorsWindowsType: dataObj.DoorsWindowsType,
                Mat: dataObj.Mat,
                IsPartitionWall: 1,
              });
              // 绘制墙洞对象
              rlWallObject.draw();
              promises.push(addEntityToDrawing(rlWallObject, true));

              rlWallObj.drawBreakWall();
              // 如果需要更新 3D 数据，则加入更新队列
              if (updateDatabase) {
                updateObjs.push(rlWallObject.getDataBase());
              }
            }
          } else {
            unvalidData.push(dataObj);
            continue;
          }
        }

        // 当前批次处理完成后继续处理下一批
        Promise.all(promises).then(() => {
          if (index < wallGuids.length) {
            queueMicrotask(processBatch); // 继续处理下一批
          } else {
            resolve({ updateObjs, unvalidData }); // 全部处理完成后返回更新数据
          }
        });
      }

      processBatch(); // 启动批量处理
    });
  } catch (error) {
    console.error("Error drawing wall holes:", error);
    return null;
  }
};

//绘制指定标准层的门窗
export const drawStdFlrDoorsWindowsData = async (
  doorsWindowsDefData,
  doorsWindowsData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  originHeight
) => {
  try {
    if (!doorsWindowsDefData || !doorsWindowsData) return null;

    // 将截面数据转换为 Map 结构，方便快速查找
    const wallSectMap = new Map(
      doorsWindowsDefData.map((item) => [item.Guid, item])
    );

    let updateObjs = []; // 记录需要更新的对象
    let unvalidData = []; //记录无效数据
    const wallGuids = Object.keys(doorsWindowsData);
    const batchSize = 100; // 批处理大小

    let index = 0;

    // 批量处理的逻辑
    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        const end = Math.min(index + batchSize, wallGuids.length);

        for (; index < end; index++) {
          let guid = wallGuids[index];
          let dataObj = doorsWindowsData[guid];

          // 跳过无效数据
          if (!dataObj) {
            continue;
          }

          // 解析 OtherData
          let otherData = null;
          if (
            typeof dataObj.OtherData === "string" &&
            dataObj.OtherData !== ""
          ) {
            otherData = JSON.parse(dataObj.OtherData);
          } else {
            otherData = dataObj.OtherData;
          }

          // 获取截面数据
          const currSectData = wallSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // 获取墙体厚度和偏心率
          const rlWallObj = getEntityData({
            Guid: dataObj.GridGuid,
            classTypeName: "rlPartitionWallSeg",
          });

          if (!rlWallObj) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          const wallThick = rlWallObj.m_sectParamData.B || 0;
          const wallEcc = rlWallObj.Ecc || 0;

          if (wallThick > 0) {
            let drawing3DData = dataObj.Drawing_3D
              ? JSON.parse(dataObj.Drawing_3D)
              : null;
            let updateModel3dData = drawing3DData ? false : true;
            // 如果层高变化，重新计算顶点的 Z 坐标
            if (
              originHeight &&
              originHeight !== currFlrHeight &&
              drawing3DData
            ) {
              drawing3DData.points = drawing3DData.points.map((point, index) =>
                index % 3 === 2
                  ? point + Number(currFlrHeight) - Number(originHeight)
                  : point
              );
              updateModel3dData = true;
            }
            let updateDrawing = false;
            if (!updateModel3dData) {
              //判断截面尺寸是否修改,考虑墙厚变化
              let sectString =
                currSectData.B + "*" + currSectData.H + "*" + wallThick;
              if (sectString != dataObj.CurrtSect) {
                updateModel3dData = true;
                updateDrawing = true;
              }
            }
            const updateDatabase =
              !drawing3DData || updateDrawing || updateModel3dData;
            // 初始化并绘制墙洞对象
            let doorsWindowsColor = getNonStructuralColor(dataObj.Mat);
            const rlWallObject = new rlDoorsWindowsData();
            rlWallObject.isWasmGeted = !updateDatabase;

            rlWallObject.initData({
              Guid: dataObj.Guid,
              No_: dataObj.No_,
              SectData: otherData ? otherData.SectData : null,
              index2dData: dataObj.Drawing_2D,
              index3dData: drawing3DData,
              points: drawing3DData ? drawing3DData.points : null,
              m_sectParamData: {
                Name: currSectData.Name,
                B: currSectData.B,
                H: currSectData.H,
                Guid: currSectData.Guid,
                Mat: dataObj.Mat,
              },
              doorsWindowsType: dataObj.DoorsWindowsType,
              m_partitionWallThick: wallThick,
              m_partitionWallEcc: wallEcc,
              Ecc: dataObj.Ecc,
              Mat: dataObj.Mat,
              HDiff: dataObj.HDiff,
              Attribute: dataObj.Attribute,
              StdFlrGuid: dataObj.StdFlrGuid,
              LevelB: currFlrLevelB,
              Height: currFlrHeight,
              m_partitionWallData: rlWallObj,
              Color: doorsWindowsColor,
              OtherData: otherData,
              CurrtSect: dataObj.CurrtSect,
            });
            // rlWallObj.m_HoleIdArray.push(dataObj.Guid);
            // 绘制墙洞对象
            rlWallObject.draw();
            promises.push(addEntityToDrawing(rlWallObject, true));
            rlWallObj.drawBreakWall();
            // 如果需要更新 3D 数据，则加入更新队列
            if (updateDatabase) {
              updateObjs.push(rlWallObject.getDataBase());
            }
          }
        }

        // 当前批次处理完成后继续处理下一批
        Promise.all(promises).then(() => {
          if (index < wallGuids.length) {
            queueMicrotask(processBatch); // 继续处理下一批
          } else {
            resolve({ updateObjs, unvalidData }); // 全部处理完成后返回更新数据
          }
        });
      }

      processBatch(); // 启动批量处理
    });
  } catch (error) {
    console.error("Error drawing wall holes:", error);
    return null;
  }
};
//绘制指定标准层的用途
export const drawStdFlrUseData = async (useData) => {
  try {
    if (!useData) return null;
    let updateObjs = []; // 记录需要更新的对象
    let unvalidData = []; //记录无效数据
    const useGuids = Object.keys(useData);
    const batchSize = 100; // 批处理大小
    let index = 0;
    // 批量处理的逻辑
    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        const end = Math.min(index + batchSize, useGuids.length);
        for (; index < end; index++) {
          let guid = useGuids[index];
          let dataObj = useData[guid];

          if (!dataObj) {
            unvalidData.push(dataObj);
            continue;
          }

          let points = [];
          let objPoints = dataObj.Points ? JSON.parse(dataObj.Points) : {};
          // 将对象的值转换为数组
          const objPointsArray = Object.values(objPoints);
          points = objPointsArray.map((p) => new McGePoint3d(p.x, p.y, p.z));
          let rlSlabObj = null;
          if (dataObj.UseType === "UseName") {
            if (dataObj.SlabGuid && dataObj.SlabGuid != "") {
              rlSlabObj = getEntityData({
                Guid: dataObj.SlabGuid,
                classTypeName: "rlSlab",
              });

              if (!rlSlabObj) {
                //若找不到关联数据，将数据清空
                unvalidData.push(dataObj);
                continue;
              }
            }
          } else {
            // let allEntGuids =
            //   dataObj.PartitionWallGuids &&
            //   typeof dataObj.PartitionWallGuids === "string"
            //     ? JSON.parse(dataObj.PartitionWallGuids)
            //     : null;
            // if (!allEntGuids || allEntGuids.length === 0) {
            //   //若找不到关联数据，将数据清空
            //   unvalidData.push(dataObj);
            //   continue;
            // }
            // for (let iii = 0; iii < allEntGuids.length; iii++) {
            //   const itemGuid = allEntGuids[iii];
            //   let obj = getEntityData({
            //     Guid: itemGuid,
            //     classTypeName: "rlPartitionWallSeg",
            //   });
            //   if (obj) continue;
            //   obj = getEntityData({
            //     Guid: itemGuid,
            //     classTypeName: "rlWallSeg",
            //   });
            //   if (!obj) {
            //     //从allEntGuids中删除itemGuid
            //     allEntGuids.splice(iii, 1);
            //     iii--;
            //   }
            // }
            // if (allEntGuids.length === 0) {
            //   //若找不到关联数据，将数据清空
            //   unvalidData.push(dataObj);
            //   continue;
            // }
          }
          // 如果points为空，则不绘制
          // if (points.length == 0) continue;
          // 初始化并绘制用途对象
          const rlUseObj = new rlUseData();
          rlUseObj.initData({
            Guid: dataObj.Guid,
            No_: dataObj.No_,
            points: points,
            useFunction: dataObj.UseFunction,
            useFunctionName: dataObj.UseFunctionName,
            m_slabId: dataObj.SlabGuid,
            StdFlrGuid: dataObj.StdFlrGuid,
            m_SlabData: rlSlabObj,
            m_useType: dataObj.UseType,
            allEntGuids:
              dataObj.PartitionWallGuids &&
              typeof dataObj.PartitionWallGuids === "string"
                ? JSON.parse(dataObj.PartitionWallGuids)
                : null,
            Color: new McCmColor(255, 255, 255),
          });
          // 绘制墙洞对象
          rlUseObj.draw();
          promises.push(addEntityToDrawing(rlUseObj, true));
        }
        // 当前批次处理完成后继续处理下一批
        Promise.all(promises).then(() => {
          if (index < useGuids.length) {
            queueMicrotask(processBatch); // 继续处理下一批
          } else {
            resolve({ updateObjs, unvalidData }); // 全部处理完成后返回更新数据
          }
        });
      }

      processBatch(); // 启动批量处理
    });
  } catch (error) {
    console.error("Error drawing wall holes:", error);
    return null;
  }
};
//绘制指定标准层数据
export const drawStdFlr = async (
  floorId,
  originHeight = null,
  originLevelB = null
) => {
  try {
    // 验证floorId是否有效
    if (floorId === null || floorId === undefined) {
      console.error("无效的floorId参数:", floorId);
      return;
    }

    // 将floorId确保为字符串类型，避免在IndexedDB查询时出错
    if (typeof floorId === "object") {
      console.error("floorId不能为对象类型:", floorId);
      return;
    }

    // 拿到对应标准层
    var rlBuilding = store.state.cadModules.rlBuilding;
    var currFlrHeight = rlBuilding.Height ?? 3000; // 当前楼层的高度
    var currFlrLevelB = 0; //rlBuilding.LevelB ?? 0;
    store.commit("globalData/setIsBldg", false);

    // 调用绘制函数
    await drawFloor(
      floorId,
      currFlrHeight,
      currFlrLevelB,
      originHeight,
      originLevelB
    );

    // FullView();
  } catch (error) {
    console.error("绘制楼层时出错：", error);
  }
};

// 整栋楼层数据设置
export const setTotalFloor = async (StdFlrGuid, Height, LevelB) => {
  // 获取构件的图层颜色
  const rlLayer = await getRlLayer();
  const [
    beamColor,
    wallColor,
    colColor,
    slabColor,
    ringBeamColor,
    subBeamColor,
    wallHoleColor,
  ] = await Promise.all([
    rlLayer.find((item) => item.Type === "rlBeamSeg"),
    rlLayer.find((item) => item.Type === "rlWallSeg"),
    rlLayer.find((item) => item.Type === "rlColSeg"),
    rlLayer.find((item) => item.Type === "rlSlabSeg"),
    rlLayer.find((item) => item.Type === "rlRingBeamSeg"),
    rlLayer.find((item) => item.Type === "rlSubBeam"),
    rlLayer.find((item) => item.Type === "rlWallHole"),
  ]);

  if (
    !beamColor ||
    !wallColor ||
    !colColor ||
    !slabColor ||
    !ringBeamColor ||
    !subBeamColor ||
    !wallHoleColor
  ) {
    return;
  }

  // 获取节点
  const jointKeyValue = await drawStdFlrJointData(StdFlrGuid, LevelB);

  // 获取柱数据并绘制
  const colData = await getRlModules("rlColSeg", StdFlrGuid);
  if (!colData) return null;

  for (const guid in colData) {
    const dataObj = colData[guid];
    if (dataObj) {
      if (typeof dataObj.OtherData === "string" && dataObj.OtherData !== "") {
        dataObj.OtherData = JSON.parse(dataObj.OtherData);
      }

      const rlColumnObject = new rlColumnData();
      rlColumnObject.isWasmGeted = true;
      rlColumnObject.initData({
        index2dData: dataObj.Drawing_2D,
        index3dData: dataObj.Drawing_3D,
        points: dataObj.Drawing_3D
          ? JSON.parse(dataObj.Drawing_3D).points
          : null,
        m_sectParamData: {
          Name: "",
          Mat: "",
          Kind: "",
          ShapeVal: "",
          Guid: "",
        },
        Color: colColor.Color,
      });
      rlColumnObject.draw();
      await addEntityToDrawing(rlColumnObject, true);
    }
  }

  // 墙布置
  const wallData = await getRlModules("rlWallSeg", StdFlrGuid);
  if (!wallData) return null;

  for (const guid in wallData) {
    const dataObj = wallData[guid];
    if (dataObj) {
      if (typeof dataObj.OtherData === "string" && dataObj.OtherData !== "") {
        dataObj.OtherData = JSON.parse(dataObj.OtherData);
      }

      const rlWallObject = new rlWallData();
      rlWallObject.isWasmGeted = true;
      rlWallObject.initData({
        index2dData: dataObj.Drawing_2D,
        index3dData: dataObj.Drawing_3D,
        points: dataObj.Drawing_3D
          ? JSON.parse(dataObj.Drawing_3D).points
          : null,
        m_sectParamData: {
          Name: "",
          Mat: "",
          Kind: "",
          B: "",
          H: "",
          Guid: "",
        },
        m_gridData: { m_wallId: "" },
        Color: wallColor.Color,
      });

      rlWallObject.draw();
      await addEntityToDrawing(rlWallObject, true);
    }
  }

  // 梁布置
  const beamData = await getRlModules("rlBeamSeg", StdFlrGuid);
  if (!beamData) return null;

  for (const guid in beamData) {
    const dataObj = beamData[guid];
    if (dataObj) {
      const rlBeamObject = new rlBeamData();
      rlBeamObject.isWasmGeted = true;
      rlBeamObject.initData({
        Guid: dataObj.Guid,
        index2dData: dataObj.Drawing_2D,
        index3dData: dataObj.Drawing_3D,
        points: dataObj.Drawing_3D
          ? JSON.parse(dataObj.Drawing_3D).points
          : null,
        m_sectParamData: {
          Name: "",
          Mat: "",
          Kind: "",
          ShapeVal: "",
          Guid: "",
        },
        Color: beamColor.Color,
      });
      rlBeamObject.draw();
      await addEntityToDrawing(rlBeamObject, true);
    }
  }

  // 梁布置
  let circleBeamData = await getRlModules("rlRingBeamSeg", StdFlrGuid);
  if (!circleBeamData) return null;

  Object.keys(circleBeamData).forEach(async (guid) => {
    let dataObj = circleBeamData[guid];
    if (dataObj) {
      let rlBeamObject = new rlRingBeamData();
      rlBeamObject.isWasmGeted = true;
      rlBeamObject.initData({
        Guid: dataObj.Guid,
        index2dData: dataObj.Drawing_2D,
        index3dData: dataObj.Drawing_3D,
        points: dataObj.Drawing_3D
          ? JSON.parse(dataObj.Drawing_3D).points
          : null,

        m_sectParamData: {
          Name: "",
          Mat: "", //材质
          Kind: "", //截面类型
          ShapeVal: "", //截面尺寸
          Guid: "",
        },

        Color: ringBeamColor.Color,
      });
      rlBeamObject.draw();
      await addEntityToDrawing(rlBeamObject, true);
    }
  });

  //获取板布置数据
  let slabData = await getRlModules("rlSlab", StdFlrGuid);
  if (!slabData) return null;

  Object.keys(slabData).forEach(async (guid) => {
    let dataObj = slabData[guid];
    if (dataObj) {
      if (gridsObjs.length) {
        let rlSlabObject = new rlSlabData();
        rlSlabObject.isWasmGeted = true;
        rlSlabObject.initData({
          Guid: dataObj.Guid,
          index2dData: dataObj.Drawing_2D,
          index3dData: dataObj.Drawing_3D,
          points: dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D).points
            : null,
          m_sectParamData: {
            Kind: "",
            Mat: "",
            Thickness: "",
            Guid: "",
          },
          Color: slabColor,
        });
        rlSlabObject.draw();
        await addEntityToDrawing(rlSlabObject, true);
      }
    }
  });

  // 墙洞布置
  let rlWallHole = await getRlModules("rlWallHole", floorId);
  if (!rlWallHole) return null;

  Object.keys(rlWallHole).forEach(async (guid) => {
    let dataObj = rlWallHole[guid];
    if (dataObj) {
      let rlWallObject = new rlWallHoleData();
      rlWallObject.isWasmGeted = true;
      rlWallObject.initData({
        Guid: dataObj.Guid,
        index2dData: dataObj.Drawing_2D,
        index3dData: dataObj.Drawing_3D,
        points: dataObj.Drawing_3D
          ? JSON.parse(dataObj.Drawing_3D).points
          : null,
        m_sectParamData: {
          Name: "",
          Mat: "", //材质
          Kind: "", //截面类型
          B: "", //墙厚
          H: "",
          Guid: "",
        },
        Color: wallHoleColor,
      });
      rlWallObject.draw();
      await addEntityToDrawing(rlWallObject, true);
    }
  });
};

//绘制指定标准层的所有数据
export const drawFloor = async (
  floorId,
  currFlrHeight,
  currFlrLevelB,
  originHeight = null,
  originLevelB = null
) => {
  try {
    // 验证floorId是否有效
    if (floorId === null || floorId === undefined) {
      console.error("drawFloor: 无效的floorId参数:", floorId);
      return;
    }

    // 将floorId确保为字符串类型，避免在IndexedDB查询时出错
    if (typeof floorId === "object") {
      console.error("drawFloor: floorId不能为对象类型:", floorId);
      return;
    }

    let rlInitFloorData = await getRlInitFloorData(floorId);
    // 如果获取数据失败，则退出
    if (!rlInitFloorData) {
      console.error("获取楼层数据失败，floorId:", floorId);
      return;
    }

    //获取构件的图层颜色
    let rlLayer = rlInitFloorData.layerData;
    if (!rlLayer || !Array.isArray(rlLayer) || rlLayer.length === 0) {
      console.error("无效的图层数据:", rlLayer);
      return;
    }
    const { data } = await getpickstatusall({
      project_id: store.state.cadModules.rlProject_id,
      flr_guid: store.state.cadModules.rlBuilding.Guid,
    });
    if (data) {
      store.commit("inspectionStore/setCheckStatus", data);
    }
    const rlLayerMap = rlLayer.reduce((acc, item) => {
      acc[item.Type] = item.Color;
      return acc;
    }, {});

    const beamColor = rlLayerMap["rlBeamSeg"];
    const wallColor = rlLayerMap["rlWallSeg"];
    const colColor = rlLayerMap["rlColSeg"];
    const slabColor = rlLayerMap["rlSlabSeg"];
    const ringBeamColor = rlLayerMap["rlRingBeamSeg"];
    const subBeamColor = rlLayerMap["rlSubBeam"];
    const wallHoleColor = rlLayerMap["rlWallHole"];
    const slabHoleColor = rlLayerMap["rlSlabHole"];
    const cantiSlabColor = rlLayerMap["rlCantiSlab"];

    if (
      !beamColor ||
      !wallColor ||
      !colColor ||
      !slabColor ||
      !ringBeamColor ||
      !subBeamColor ||
      !wallHoleColor ||
      !cantiSlabColor
    )
      return;
    let stdFlrData = rlInitFloorData.stdFlrData || {};

    //绘制节点
    let jointKeyValue = await drawStdFlrJointData(
      stdFlrData["rlJoint"],
      currFlrLevelB
    );

    let totalUpdateObjs = {}; //记录需要在数据库更新的数据
    let totalUnvalidData = {}; //记录无效数据
    //绘制轴线
    let axisKeyValue = {};
    let axisResult = await drawStdFlrAxisData(
      stdFlrData["rlAxis"],
      jointKeyValue,
      stdFlrData["rlGrid"]
    );
    axisKeyValue = axisResult ? axisResult.axisKeyValue : {};
    if (axisResult && axisResult.unvalidData && axisResult.unvalidData.length) {
      totalUnvalidData["rlAxis"] = axisResult.unvalidData;
    }

    if (store.state.displayData.axisDisplay) {
      toggleAxisDist(true);
    }

    //绘制网格
    let gridKeyValue = {};
    let gridResult = await drawStdFlrGridData(
      stdFlrData["rlGrid"],
      jointKeyValue,
      axisKeyValue
    );
    gridKeyValue = gridResult ? gridResult.gridKeyValue : {};
    if (gridResult && gridResult.unvalidData && gridResult.unvalidData.length) {
      totalUnvalidData["rlGrid"] = gridResult.unvalidData;
    }
    if (gridResult && gridResult.updateObjs && gridResult.updateObjs.length) {
      totalUpdateObjs["rlGrid"] = gridResult.updateObjs;
    }

    currFlrHeight = Number(currFlrHeight);
    currFlrLevelB = Number(currFlrLevelB);
    originHeight = Number(originHeight);
    originLevelB = Number(originLevelB);

    //获取梁截面
    let beamSectData = rlInitFloorData.beamSectData;
    let updateAndDelDatas = await drawStdFlrBeamData(
      beamSectData,
      stdFlrData["rlBeamSeg"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      beamColor,
      subBeamColor,
      ringBeamColor,
      originHeight,
      originLevelB,
      stdFlrData["rlGridC"]
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlBeamSeg"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlBeamSeg"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //获取柱截面
    let colSectData = rlInitFloorData.colSectData;
    updateAndDelDatas = await drawStdFlrColData(
      colSectData,
      stdFlrData["rlColSeg"],
      jointKeyValue,
      currFlrHeight,
      currFlrLevelB,
      colColor,
      originHeight,
      originLevelB,
      stdFlrData["rlJointC"]
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlColSeg"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlColSeg"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //获取环梁截面
    let ringBeamSectData = rlInitFloorData.ringBeamSectData;
    updateAndDelDatas = await drawStdFlrRingBeamData(
      ringBeamSectData,
      stdFlrData["rlRingBeamSeg"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      ringBeamColor,
      originHeight,
      originLevelB
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlRingBeamSeg"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlRingBeamSeg"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //获取墙截面
    let wallSectData = rlInitFloorData.wallSectData;

    updateAndDelDatas = await drawStdFlrWallData(
      wallSectData,
      stdFlrData["rlWallSeg"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      wallColor,
      originHeight,
      originLevelB,
      stdFlrData["rlGridC"]
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlWallSeg"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlWallSeg"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //获取次梁截面
    updateAndDelDatas = await drawStdFlrSubBeamData(
      beamSectData,
      stdFlrData["rlSubBeam"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      subBeamColor,
      originHeight,
      originLevelB
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlSubBeam"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlSubBeam"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //获取隔墙截面
    let PartitionWallSectData = rlInitFloorData.PartitionWallSectData;

    updateAndDelDatas = await drawStdFlrPartitionWallData(
      PartitionWallSectData,
      stdFlrData["rlPartitionWallSeg"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      originHeight,
      originLevelB,
      stdFlrData["rlGridC"]
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlPartitionWallSeg"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlPartitionWallSeg"] = updateAndDelDatas.unvalidData;
    }

    updateAndDelDatas = null;
    //获取墙洞截面
    let wallHoleSectData = rlInitFloorData.wallHoleDefData;
    updateAndDelDatas = await drawStdFlrWallHoleData(
      wallHoleSectData,
      stdFlrData["rlWallHole"],
      stdFlrData["rlPartitionWallSeg"] || [],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      wallHoleColor,
      originHeight,
      stdFlrData["rlGridC"]
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlWallHole"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlWallHole"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //获取板截面
    let slabSectData = rlInitFloorData.slabSectData;
    updateAndDelDatas = await drawStdFlrSlabData(
      slabSectData,
      stdFlrData["rlSlab"],
      stdFlrData["rlStdFlrPara"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      slabColor,
      originHeight,
      originLevelB
    );

    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlSlab"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlSlab"] = updateAndDelDatas.unvalidData;
    }

    updateAndDelDatas = null;

    //获取悬挑板截面
    let cantiSlabSectData = rlInitFloorData.cantiSlabDefData;
    updateAndDelDatas = await drawStdFlrCantiSlabData(
      cantiSlabSectData,
      stdFlrData["rlCantiSlab"],
      stdFlrData["rlStdFlrPara"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      cantiSlabColor,
      originHeight
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlCantiSlab"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlCantiSlab"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;

    //获取板洞截面
    let slabHoleSectData = rlInitFloorData.slabHoleDefData;

    updateAndDelDatas = await drawStdFlrSlabHoleData(
      slabHoleSectData,
      stdFlrData["rlSlabHole"],
      jointKeyValue,
      currFlrHeight,
      currFlrLevelB,
      slabHoleColor
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlSlabHole"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlSlabHole"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //获取门窗截面
    let doorsWindowsDefData = rlInitFloorData.doorsWindowsDefData;
    updateAndDelDatas = await drawStdFlrDoorsWindowsData(
      doorsWindowsDefData,
      stdFlrData["rlDoorsWindows"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      originHeight
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlDoorsWindows"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlDoorsWindows"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //绘制用途
    updateAndDelDatas = await drawStdFlrUseData(stdFlrData["rlUse"]);
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlUse"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlUse"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;

    await updateBulkRlStdFlrFieldDatas(floorId, totalUpdateObjs);
    await delBulkRlStdFlrFieldDatas(floorId, totalUnvalidData);
    if (
      totalUnvalidData &&
      typeof totalUnvalidData === "object" &&
      Object.keys(totalUnvalidData).length > 0
    ) {
      //有错误信息出现，
      try {
        const projectId = store.state?.cadModules?.rlProject_id || "";
        if (projectId) {
          const res = await getAllDataWithDexie(`project${projectId}`);
          uperrormodel({
            project_id: projectId,
            json:
              JSON.stringify({
                indexData: res,
                totalUnvalidData,
              }) || {},
          });
        }
      } catch {}
    }

    rlAppObj.rlMxDrawObject.updateDisplay();
  } catch (error) {
    console.error("绘制楼层时出错：", error);
    // 可以根据需要处理错误
  }
};

//楼层复制---弃用
export const copyFloor = async (
  copyFloorNo,
  copyType /**1==>整层复制,3==>轴网复制，2==>局部复制 */,
  bChangeNow /*是否立即切换到新的标准层 */
) => {
  try {
    let allRlStdFlr = await getrlStdFlrAll();
    let lastNo = 0; //记录最后一个标准层No
    let totalData = null; //拷贝的源数据
    allRlStdFlr.forEach((item) => {
      if (item.No_ == copyFloorNo) {
        totalData = item;
      }
      if (lastNo < item.No_) {
        lastNo = item.No_;
      }
    });
    if (!totalData) return;

    //创建一个标准层
    let copyData = {};

    //整层复制
    if (copyType == 1) {
      copyData = JSON.parse(JSON.stringify(totalData));
      //给一个新的标准层guid
      copyData.Guid = generate_guid();
      copyData.No_ = lastNo + 1; //编号赋值--to do...

      //获取复制标准层中所有数据
      let jointKeyValue = {};
      let newJointData = {};
      //获取节点
      let jointData = totalData.rlJoint; //await getRlModules("rlJoint", copyFloorId);
      if (jointData) {
        Object.keys(jointData).forEach(async (guid) => {
          let dataObj = jointData[guid];
          let rlPointObj = new rlJointData();
          rlPointObj.initData({
            m_pt: [dataObj["X"], dataObj["Y"], currFlrLevelB],
            StdFlrGuid: copyData.Guid,
          });
          await addEntityToDrawing(rlPointObj, true);
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          jointKeyValue[guid] = rlPointObj.Guid;
          newJointData[rlPointObj.Guid] = rlPointObj;
        });
        copyData.rlJoint = newJointData;
      }

      // 轴线
      let axisKeyValue = {};
      let newAxisData = {};
      let axisData = totalData.rlAxis; //await getRlModules("rlAxis", copyFloorId);
      if (axisData) {
        Object.keys(axisData).forEach(async (guid) => {
          let dataObj = axisData[guid];
          let rlAxisObj = new rlAxisData();
          rlAxisObj.initData({
            m_stJoint: jointKeyValue[dataObj.Jt1Guid],
            m_edJoint: jointKeyValue[dataObj.Jt2Guid],
            IsMainAxis: dataObj.IsMainAxis,
            Name: dataObj.Name,
            StdFlrGuid: copyData.Guid,
          });
          await addEntityToDrawing(rlAxisObj, true);
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          // dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          axisKeyValue[guid] = rlAxisObj.Guid;
          newAxisData[rlAxisObj.Guid] = rlAxisObj;
        });
        copyData.rlAxis = newAxisData;
      }

      // 网格
      let gridKeyValue = {};
      let newGridData = {};
      let gridData = totalData.rlGrid; //await getRlModules("rlGrid", copyFloorId);
      if (gridData) {
        Object.keys(gridData).forEach(async (guid) => {
          let dataObj = gridData[guid];
          if (dataObj.Jt0Guid) {
            let rlLineGridObj = new rlGridArcData(); // 简化对象创建
            rlLineGridObj.initData({
              m_centerJoint: dataObj.Jt0Guid
                ? jointKeyValue[dataObj.Jt0Guid]
                : null,
              m_stJoint: jointKeyValue[dataObj.Jt1Guid],
              m_edJoint: jointKeyValue[dataObj.Jt2Guid],
              centerPoint: jointKeyValue[dataObj.Jt0Guid].m_pt,
              StdFlrGuid: copyData.Guid,
              m_Axis: axisKeyValue[dataObj.AxisGuid],
              Guid: dataObj.Guid,
            });
            await addEntityToDrawing(rlLineGridObj, true);
          } else {
            let rlLineGridObj = new rlGridData();
            rlLineGridObj.initData({
              m_stJoint: jointKeyValue[dataObj.Jt1Guid],
              m_edJoint: jointKeyValue[dataObj.Jt2Guid],
              StdFlrGuid: copyData.Guid,
              m_Axis: axisKeyValue[dataObj.AxisGuid],
            });
            await addEntityToDrawing(rlLineGridObj, true);
          }

          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          // dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          // dataTmp.AxisGuid = axisKeyValue[dataTmp.AxisGuid];
          gridKeyValue[guid] = rlLineGridObj.Guid;
          newGridData[rlLineGridObj.Guid] = rlLineGridObj;
        });
        copyData.rlGrid = newGridData;
      }

      //墙
      let newWallData = {};
      let wallData = totalData.rlWallSeg;
      if (wallData) {
        Object.keys(wallData).forEach(async (guid) => {
          let dataObj = wallData[guid];
          let rlWallObject = new rlWallData();
          rlWallObject.isWasmGeted = true;
          rlWallObject.initData({
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            // index2dData: dataObj.Drawing_2D,
            // index3dData: dataObj.Drawing_3D
            //   ? JSON.parse(dataObj.Drawing_3D).faces
            //   : null,
            // index3dData: JSON.parse(dataObj.Drawing_3D),
            // points: dataObj.Drawing_3D
            //   ? JSON.parse(dataObj.Drawing_3D).points
            //   : null,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat, //材质
              Kind: currSectData.Kind, //截面类型
              B: currSectData.B, //墙厚
              H: currSectData.H,
              Guid: currSectData.Guid,
            },

            Ecc: dataObj.Ecc,
            HDiff1: dataObj.HDiff1,
            HDiff2: dataObj.HDiff2,
            HDiffB: dataObj.HDiffB,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            StdFlrGuid: copyData.Guid,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            //m_sectData: rlWallsectObject,
            m_gridData: gridKeyValue[dataObj.GridGuid],
            Color: wallColor,
            LinkGuids: dataObj.LinkGuids?.split(","),
          });

          rlWallObject.draw();
          await addEntityToDrawing(rlWallObject, true);
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
          newWallData[rlWallObject.Guid] = rlWallObject;
        });
        copyData.rlWallSeg = newWallData;
      }

      //梁
      let newBeamData = {};
      let beamData = totalData.rlBeamSeg;

      if (beamData) {
        Object.keys(beamData).forEach(async (guid) => {
          let dataObj = beamData[guid];
          let rlBeamObject = new rlBeamData();
          rlBeamObject.isWasmGeted = true;
          rlBeamObject.initData({
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            Guid: dataObj.Guid,
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: dataObj.Drawing_3D,
            points: dataObj.Drawing_3D
              ? JSON.parse(dataObj.Drawing_3D).points
              : null,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat, //材质
              Kind: currSectData.Kind, //截面类型
              ShapeVal: currSectData.ShapeVal, //截面尺寸
              Guid: currSectData.Guid,
            },
            StdFlrGuid: copyData.Guid,
            Ecc: dataObj.Ecc,
            HDiff1: dataObj.HDiff1,
            HDiff2: dataObj.HDiff2,
            Rotation: dataObj.Rotation,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            m_gridData: gridKeyValue[dataObj.GridGuid],
            Color: beamColor,
            LinkGuids: dataObj.LinkGuids?.split(","),
          });
          rlBeamObject.draw();
          await addEntityToDrawing(rlBeamObject, true);
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
          newBeamData[dataObj.Guid] = dataObj;
        });
        copyData.rlBeamSeg = newBeamData;
      }

      //柱
      let newColData = {};
      let colData = totalData.rlColSeg;
      if (colData) {
        Object.keys(colData).forEach(async (guid) => {
          let dataTmp = colData[guid];
          let rlColumnObject = new rlColumnData();
          rlColumnObject.isWasmGeted = true;
          rlColumnObject.initData({
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            Guid: dataObj.Guid,
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: dataObj.Drawing_3D,
            points: dataObj.Drawing_3D
              ? JSON.parse(dataObj.Drawing_3D).points
              : null,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat, //材质
              Kind: currSectData.Kind, //截面类型
              ShapeVal: currSectData.ShapeVal, //截面尺寸
              Guid: currSectData.Guid,
            },
            StdFlrGuid: copyData.Guid,
            EccX: dataObj.EccX,
            EccY: dataObj.EccY,
            Rotation: dataObj.Rotation,
            HDiffB: dataObj.HDiffB,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            m_JointData: jointKeyValue[dataObj.JtGuid],
            Color: colColor,
          });
          rlColumnObject.draw();
          await addEntityToDrawing(rlColumnObject, true);
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.JtGuid = jointKeyValue[dataTmp.JtGuid];
          newColData[dataObj.Guid] = dataObj;
        });
        copyData.rlColSeg = newColData;
      }

      //板
      let newSlabData = {};
      let slabData = totalData.rlSlab;
      if (slabData) {
        Object.keys(slabData).forEach(async (guid) => {
          let dataObj = slabData[guid];
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          //切分后重新组合
          let splitGridsGuid = dataObj.GridsGuid.split(",");
          let newGridsGuid = "";
          splitGridsGuid.forEach((element) => {
            if (gridKeyValue[element]) {
              newGridsGuid += gridKeyValue[element];
              newGridsGuid += ",";
            }
          });

          // dataTmp.GridsGuid = newGridsGuid;

          let rlSlabObject = new rlSlabData();
          rlSlabObject.isWasmGeted = true;
          rlSlabObject.initData({
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: dataObj.Drawing_3D,
            points: dataObj.Drawing_3D
              ? JSON.parse(dataObj.Drawing_3D).points
              : null,
            m_sectParamData: {
              Kind: currSectData.Kind,
              Mat: currSectData.Mat,
              Thickness: currSectData.Thickness,
              Guid: currSectData.Guid,
            },
            StdFlrGuid: copyData.Guid,
            Thickness: dataObj.Thickness,
            RoomlsHole: dataObj.RoomlsHole,
            VertexX: dataObj.VertexX,
            VertexY: dataObj.VertexY,
            VertexZ: dataObj.VertexZ,
            ParaVal: defaultThick,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            gridsObjs: newGridsGuid,
            Color: dataObj.Color,
          });
          rlSlabObject.draw();
          await addEntityToDrawing(rlSlabObject, true);

          newSlabData[rlSlabObject.Guid] = rlSlabObject;
        });
        copyData.rlSlab = newSlabData;
      }

      //标准层参数
      let StdFlrParaData = totalData.rlStdFlrPara;
      if (StdFlrParaData) {
        StdFlrParaData.forEach((item) => {
          item.StdFlrGuid = copyData.Guid;
        });
        copyData.rlStdFlrPara = StdFlrParaData;
      }
    } else if (copyType == 3) {
      copyData.Guid = generate_guid();
      copyData.No_ = lastNo + 1;
      copyData.Height = totalData.Height;

      //获取复制标准层中所有的轴线、节点和网格数据
      let jointKeyValue = {};
      let newJointData = {};
      //获取节点
      let jointData = totalData.rlJoint; //await getRlModules("rlJoint", copyFloorId);
      if (jointData) {
        Object.keys(jointData).forEach((guid) => {
          let dataTmp = jointData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          jointKeyValue[guid] = dataTmp.Guid;
          newJointData[dataTmp.Guid] = dataTmp;
        });
        copyData.rlJoint = newJointData;
      }

      // 轴线
      let axisKeyValue = {};
      let newAxisData = {};
      let axisData = totalData.rlAxis; //await getRlModules("rlAxis", copyFloorId);
      if (axisData) {
        Object.keys(axisData).forEach((guid) => {
          let dataTmp = axisData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          axisKeyValue[guid] = dataTmp.Guid;
          newAxisData[dataTmp.Guid] = dataTmp;
        });
        copyData.rlAxis = newAxisData;
      }

      // 网格
      let gridKeyValue = {};
      let newGridData = {};
      let gridData = totalData.rlGrid; //await getRlModules("rlGrid", copyFloorId);
      if (gridData) {
        Object.keys(gridData).forEach((guid) => {
          let dataTmp = gridData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          dataTmp.AxisGuid = axisKeyValue[dataTmp.AxisGuid];
          gridKeyValue[guid] = dataTmp.Guid;
          newGridData[dataTmp.Guid] = dataTmp;
        });
        copyData.rlGrid = newGridData;
      }

      //标准层参数
      let StdFlrParaData = totalData.rlStdFlrPara;
      if (StdFlrParaData) {
        StdFlrParaData.forEach((item) => {
          item.StdFlrGuid = copyData.Guid;
        });
        copyData.rlStdFlrPara = StdFlrParaData;
      }
    }

    //将复制数据写入indexdb
    await addrlStdFlr(copyData);
    //绘制
    if (bChangeNow) {
      //清空当前画布
      // rlAppObj.rlMxDrawObject.eraseAllMxEntity();
      clearDrawing();
      drawStdFlr(copyData.Guid);
      store.commit("globalData/setStdFlr", copyData.Guid);
    }
  } catch (error) {
    console.error("复制楼层时出错：", error);
  }
};

//切换标准层
export const changeFloor = async (
  floorId,
  originHeight = null,
  originLevelB = null
) => {
  try {
    // 验证floorId是否有效
    if (floorId === null || floorId === undefined) {
      console.error("changeFloor: 无效的floorId参数:", floorId);
      return;
    }

    // 将floorId确保为字符串类型，避免在IndexedDB查询时出错
    if (typeof floorId === "object") {
      console.error("changeFloor: floorId不能为对象类型:", floorId);
      return;
    }

    //清空当前画布
    await clearDrawing();
    showFullScreenLoading("模型加载中...");

    //清空已加载的轴线命名数据
    store.commit("globalData/clearGuidToRlAxisLineLoad");
    toggleAxisDist(false); //关闭轴线命名
    rlAppObj._rlMx.MxFun.updateDisplay();
    //

    await drawStdFlr(floorId, originHeight, originLevelB);
    //

    //清空撤销回退数据
    await initRevokeReDoData();

    tryHideFullScreenLoading();
  } catch (error) {
    console.error("切换楼层时出错：", error);
    tryHideFullScreenLoading();
  }
};
// 楼层组装（整栋）
// export const drawTotalFloor = async () => {
//   try {
//     store.commit("globalData/setIsBldg", true);

//     await update3Dview();
//   } catch (error) {
//     console.error("楼层组装时出错：", error);
//   }
// };

export const clearDrawing = () => {
  try {
    if (store.state.rlEntData.totalEntityData) {
      //清空当前画布
      Object.keys(store.state.rlEntData.totalEntityData).forEach((key) => {
        let data = store.state.rlEntData.totalEntityData[key];
        for (let j = 0; j < data.length; j++) {
          let entity = data[j];
          if (entity) {
            if (
              entity.classTypeName == "rlColSeg" ||
              entity.classTypeName == "rlBeamSeg" ||
              entity.classTypeName == "rlSlab"
            ) {
              entity.eraseJcData();
            } else if (entity.classTypeName == "rlWallSeg") {
              entity.eraseJcData();
              entity.eraseOtherDraw();
            } else if (entity.classTypeName == "rlJoint") {
              entity.mcDbCircleIds.forEach((item) => {
                item.getMcDbEntity().erase();
              });
            } else if (entity.classTypeName == "rlJointC") {
              entity.mcDbCircleIds.forEach((item) => {
                item.getMcDbEntity().erase();
              });
            } else if (entity.classTypeName == "rlAxis") {
              entity.m_stText?.erase();
              entity.m_edText?.erase();
              entity.m_stLineTmp?.erase();
              entity.m_edLineTmp?.erase();
              entity.m_stCircle?.erase();
              entity.m_edCircle?.erase();
            } else if (entity.classTypeName == "rlAxisC") {
              entity.m_stText?.erase();
              entity.m_edText?.erase();
              entity.m_stLineTmp?.erase();
              entity.m_edLineTmp?.erase();
              entity.m_stCircle?.erase();
              entity.m_edCircle?.erase();
            } else if (entity.classTypeName == "rlDoorsWindows") {
              entity.eraseOtherDraw();
            } else if (entity.classTypeName == "rlWallHole") {
              entity.eraseOtherDraw();
            } else if (entity.classTypeName == "rlPartitionWallSeg") {
              entity.eraseOtherDraw();
            }
            entity.mcDbId?.getMcDbEntity()?.erase();
            if (entity.ModelType) {
              entity.m_TextObj?.erase();
              entity.StrengthTextObj?.erase();
              entity.ModelNoTextObj?.erase();
            }
          }
        }
      });
    }

    store.commit("rlEntData/clearEntityData");
    // rlAppObj.mxcadObject.newFile();
    // // del_all_entity_group();
    // rlAppObj.rlMxDatabase.getGroup("rlPointGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlLineAxisGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.clear();

    // rlAppObj.rlMxDatabase.getGroup("rlBeamGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlColumnGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlWallGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlSlabGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlLineGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlCircleGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlTextGroup")?.clear();

    // rlAppObj.rlMxDatabase.getGroup("rlWallHoleGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlSubBeamGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlRingBeamGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlSlabHole")?.clear();
  } catch (error) {
    console.error("清空画布时出错：", error);
  }
};

// -------------- 2024年6月5日新写
//楼层复制-自然层
export const copyStlFloor = async (
  totalData, // 标准层数据
  copyType /**1==>整层复制,3==>轴网复制，2==>局部复制 */,
  bChangeNow /*是否立即切换到新的标准层 */,
  addHeight /*新增标准层的层高*/
) => {
  // console.log(
  //   totalData, // 标准层数据
  //   copyType /**1==>整层复制,3==>轴网复制，2==>局部复制 */,
  //   bChangeNow /*是否立即切换到新的标准层 */,
  //   addHeight
  // );
  try {
    let allRlStdFlr = await getrlStdFlrAll();
    let lastNo = 0; //记录最后一个标准层No
    if (allRlStdFlr.length > 0) {
      lastNo = Math.max(...allRlStdFlr.map((item) => item.No_));
    }
    const originHeight = totalData.Height;
    //创建一个标准层
    let copyData = {};
    copyData.Guid = generate_guid(); //给一个新的标准层guid
    copyData.No_ = lastNo + 1;

    //整层复制
    if (copyType == 1) {
      //获取复制标准层中所有数据
      let jointKeyValue = {};
      let newJointData = {};
      let newEntGuidArray = {
        beamGuids: [],
        columnGuids: [],
        slabGuids: [],
        wallGuids: [],
        partitionWallGuids: [],
      };
      //获取节点
      const jointData = totalData.rlJoint; //await getRlModules("rlJoint", copyFloorId);
      if (jointData) {
        Object.keys(jointData).forEach((guid) => {
          let dataTmp = jointData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          jointKeyValue[guid] = dataTmp.Guid;
          newJointData[dataTmp.Guid] = dataTmp;
        });
      }
      copyData.rlJoint = newJointData;

      // 轴线
      let axisKeyValue = {};
      let newAxisData = {};
      const axisData = totalData.rlAxis; //await getRlModules("rlAxis", copyFloorId);
      if (axisData) {
        Object.keys(axisData).forEach((guid) => {
          let dataTmp = axisData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          if (
            jointKeyValue[dataTmp.Jt1Guid] &&
            jointKeyValue[dataTmp.Jt2Guid]
          ) {
            dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
            dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
            axisKeyValue[guid] = dataTmp.Guid;
            newAxisData[dataTmp.Guid] = dataTmp;
          } else {
          }
        });
      }
      copyData.rlAxis = newAxisData;
      // 网格
      let gridKeyValue = {};
      let newGridData = {};
      const gridData = totalData.rlGrid; //await getRlModules("rlGrid", copyFloorId);

      if (gridData) {
        Object.keys(gridData).forEach((guid) => {
          let dataTmp = gridData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          if (
            jointKeyValue[dataTmp.Jt1Guid] &&
            jointKeyValue[dataTmp.Jt2Guid] //&&
            //axisKeyValue[dataTmp.AxisGuid]
          ) {
            dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
            dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
            if (dataTmp.Jt0Guid) {
              dataTmp.Jt0Guid = jointKeyValue[dataTmp.Jt0Guid];
            }
            dataTmp.AxisGuid = axisKeyValue[dataTmp.AxisGuid];
            gridKeyValue[guid] = dataTmp.Guid;
            newGridData[dataTmp.Guid] = dataTmp;
          } else {
          }
        });
      }
      copyData.rlGrid = newGridData;

      //墙
      let newWallData = {};
      const wallData = totalData.rlWallSeg;
      if (wallData) {
        Object.keys(wallData).forEach((guid) => {
          let dataTmp = wallData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.ModelNo = "";
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.RelationGuid = "";
          if (gridKeyValue[dataTmp.GridGuid]) {
            dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
            newWallData[dataTmp.Guid] = dataTmp;
          }
          newEntGuidArray.wallGuids.push({
            guid: guid,
            dataGuid: dataTmp.Guid,
          });
        });
      }
      copyData.rlWallSeg = newWallData;

      //梁
      let newBeamData = {};
      const beamData = totalData.rlBeamSeg;

      if (beamData) {
        Object.keys(beamData).forEach((guid) => {
          let dataTmp = beamData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.ModelNo = "";
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.RelationGuid = "";
          if (gridKeyValue[dataTmp.GridGuid]) {
            dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
            newBeamData[dataTmp.Guid] = dataTmp;
          }
          newEntGuidArray.beamGuids.push({
            guid: guid,
            dataGuid: dataTmp.Guid,
          });
        });
      }
      copyData.rlBeamSeg = newBeamData;

      //柱
      let newColData = {};
      const colData = totalData.rlColSeg;
      if (colData) {
        Object.keys(colData).forEach((guid) => {
          let dataTmp = colData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.ModelNo = "";
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.RelationGuid = "";
          if (jointKeyValue[dataTmp.JtGuid]) {
            dataTmp.JtGuid = jointKeyValue[dataTmp.JtGuid];
            newColData[dataTmp.Guid] = dataTmp;
          }
          newEntGuidArray.columnGuids.push({
            guid: guid,
            dataGuid: dataTmp.Guid,
          });
        });
      }
      copyData.rlColSeg = newColData;

      //板
      let slabKeyValue = {};
      let newSlabData = {};
      const slabData = totalData.rlSlab;
      if (slabData) {
        Object.keys(slabData).forEach((guid) => {
          let dataTmp = slabData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.ModelNo = "";
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.RelationGuid = "";
          //切分后重新组合
          let splitGridsGuid = dataTmp.GridsGuid.split(",");
          let newGridsGuid = "";
          splitGridsGuid.forEach((element) => {
            if (gridKeyValue[element]) {
              newGridsGuid += gridKeyValue[element];
              newGridsGuid += ",";
            }
          });

          dataTmp.GridsGuid = newGridsGuid;
          newSlabData[dataTmp.Guid] = dataTmp;
          slabKeyValue[guid] = dataTmp.Guid;
          // if (dataTmp.RoomIsHole)
          newEntGuidArray.slabGuids.push({
            guid: guid,
            dataGuid: dataTmp.Guid,
          });
        });
      }
      copyData.rlSlab = newSlabData;

      //悬挑板
      let newCantiSlabData = {};
      const cantiSlabData = totalData.rlCantiSlab;
      if (cantiSlabData) {
        Object.keys(cantiSlabData).forEach((guid) => {
          let dataTmp = cantiSlabData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          if (gridKeyValue[dataTmp.GridGuid]) {
            dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
            newCantiSlabData[dataTmp.Guid] = dataTmp;
          }
        });
      }
      copyData.rlCantiSlab = newCantiSlabData;

      //隔墙
      let newSubWallData = {};
      let subWallKeyValue = {};
      const subWallData = totalData.rlPartitionWallSeg;

      if (subWallData) {
        Object.keys(subWallData).forEach((guid) => {
          let dataTmp = subWallData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.Height =
          //   originHeight == dataTmp.Height ? addHeight : dataTmp.Height;
          if (gridKeyValue[dataTmp.GridGuid]) {
            dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
            newSubWallData[dataTmp.Guid] = dataTmp;
            subWallKeyValue[guid] = dataTmp.Guid;
          } else {
            newSubWallData[dataTmp.Guid] = dataTmp;
            subWallKeyValue[guid] = dataTmp.Guid;
          }
          newEntGuidArray.partitionWallGuids.push({
            guid: guid,
            dataGuid: dataTmp.Guid,
          });
        });
      }
      copyData.rlPartitionWallSeg = newSubWallData;

      //墙洞
      let newWallHoleData = {};
      const wallHoleData = totalData.rlWallHole;
      if (wallHoleData) {
        Object.keys(wallHoleData).forEach((guid) => {
          let dataTmp = wallHoleData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          if (dataTmp.IsPartitionWall === 0 && gridKeyValue[dataTmp.GridGuid]) {
            dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
            newWallHoleData[dataTmp.Guid] = dataTmp;
          } else if (
            dataTmp.IsPartitionWall === 1 &&
            subWallKeyValue[dataTmp.GridGuid]
          ) {
            dataTmp.GridGuid = subWallKeyValue[dataTmp.GridGuid];
            newWallHoleData[dataTmp.Guid] = dataTmp;
          }
        });
      }

      copyData.rlWallHole = newWallHoleData;

      //板洞
      let newSlabHoleData = {};
      const slabHoleData = totalData.rlSlabHole;

      if (slabHoleData) {
        Object.keys(slabHoleData).forEach((guid) => {
          let dataTmp = slabHoleData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          if (jointKeyValue[dataTmp.JtGuid] && slabKeyValue[dataTmp.SlabGuid]) {
            dataTmp.JtGuid = jointKeyValue[dataTmp.JtGuid];
            dataTmp.SlabGuid = slabKeyValue[dataTmp.SlabGuid]; //关联楼板
            newSlabHoleData[dataTmp.Guid] = dataTmp;
          }
        });
      }
      copyData.rlSlabHole = newSlabHoleData;

      //圈梁
      let newRingBeamData = {};
      const ringBeamData = totalData.rlRingBeamSeg;
      if (ringBeamData) {
        Object.keys(ringBeamData).forEach((guid) => {
          let dataTmp = ringBeamData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
        });
      }
      copyData.rlRingBeamSeg = newRingBeamData;

      //次梁
      let newSubBeamData = {};
      const subBeamData = totalData.rlSubBeam;
      if (subBeamData) {
        Object.keys(subBeamData).forEach((guid) => {
          let dataTmp = subBeamData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
        });
      }

      copyData.rlSubBeam = newSubBeamData;

      // //门窗
      // let newDoorWindowData = {};
      // const doorWindowData = totalData.rlDoorsWindows;
      // if (doorWindowData) {
      //   Object.keys(doorWindowData).forEach((guid) => {
      //     let dataTmp = doorWindowData[guid];
      //     dataTmp.Guid = generate_guid();
      //     dataTmp.StdFlrGuid = copyData.Guid;
      //     if (subWallKeyValue[dataTmp.GridGuid]) {
      //       dataTmp.GridGuid = subWallKeyValue[dataTmp.GridGuid];
      //       newDoorWindowData[dataTmp.Guid] = dataTmp;
      //     } else {
      //       newDoorWindowData[dataTmp.Guid] = dataTmp;
      //     }
      //   });
      // }

      // copyData.rlDoorsWindows = newDoorWindowData;
      //用途
      let newUsageData = {};
      const usageData = totalData.rlUse;
      if (usageData) {
        Object.keys(usageData).forEach((guid) => {
          let dataTmp = usageData[guid];
          // 如果points为空，则不复制
          if (dataTmp.Points != "{}") {
            dataTmp.Guid = generate_guid();
            let PartitionWallGuids = dataTmp.PartitionWallGuids
              ? JSON.parse(dataTmp.PartitionWallGuids)
              : {};
            if (PartitionWallGuids) {
              if (PartitionWallGuids.wallGuids) {
                for (let i = 0; i < PartitionWallGuids.wallGuids.length; i++) {
                  let findWall = newEntGuidArray.wallGuids.find(
                    (item2) => item2.guid == PartitionWallGuids.wallGuids[i]
                  );
                  if (findWall) {
                    PartitionWallGuids.wallGuids[i] = findWall.dataGuid;
                  }
                }
              }
              if (PartitionWallGuids.slabGuids) {
                for (let i = 0; i < PartitionWallGuids.slabGuids.length; i++) {
                  let findSlab = newEntGuidArray.slabGuids.find(
                    (item2) => item2.guid == PartitionWallGuids.slabGuids[i]
                  );
                  if (findSlab) {
                    PartitionWallGuids.slabGuids[i] = findSlab.dataGuid;
                  }
                }
              }
              if (PartitionWallGuids.beamGuids) {
                for (let i = 0; i < PartitionWallGuids.beamGuids.length; i++) {
                  let findBeam = newEntGuidArray.beamGuids.find(
                    (item2) => item2.guid == PartitionWallGuids.beamGuids[i]
                  );
                  if (findBeam) {
                    PartitionWallGuids.beamGuids[i] = findBeam.dataGuid;
                  }
                }
              }
              if (PartitionWallGuids.columnGuids) {
                for (
                  let i = 0;
                  i < PartitionWallGuids.columnGuids.length;
                  i++
                ) {
                  let findColumn = newEntGuidArray.columnGuids.find(
                    (item2) => item2.guid == PartitionWallGuids.columnGuids[i]
                  );
                  if (findColumn) {
                    PartitionWallGuids.columnGuids[i] = findColumn.dataGuid;
                  }
                }
              }
              if (PartitionWallGuids.partitionWallGuids) {
                for (
                  let i = 0;
                  i < PartitionWallGuids.partitionWallGuids.length;
                  i++
                ) {
                  let findPartitionWall =
                    newEntGuidArray.partitionWallGuids.find(
                      (item2) =>
                        item2.guid == PartitionWallGuids.partitionWallGuids[i]
                    );
                  if (findPartitionWall) {
                    PartitionWallGuids.partitionWallGuids[i] =
                      findPartitionWall.dataGuid;
                  }
                }
              }
              dataTmp.PartitionWallGuids = JSON.stringify(PartitionWallGuids);
            }
            dataTmp.StdFlrGuid = copyData.Guid;
            if (slabKeyValue[dataTmp.SlabGuid]) {
              dataTmp.SlabGuid = slabKeyValue[dataTmp.SlabGuid];
            }
            newUsageData[dataTmp.Guid] = dataTmp;
          }
        });
      }
      copyData.rlUse = newUsageData;
      //标准层参数
      const StdFlrParaData = totalData.rlStdFlrPara;
      if (StdFlrParaData) {
        StdFlrParaData.forEach((item) => {
          item.StdFlrGuid = copyData.Guid;
        });
      }
      copyData.rlStdFlrPara = StdFlrParaData;
    } else if (copyType == 3) {
      //获取复制标准层中所有的轴线、节点和网格数据
      let jointKeyValue = {};
      let newJointData = {};
      //获取节点
      let jointData = totalData.rlJoint; //await getRlModules("rlJoint", copyFloorId);
      if (jointData) {
        Object.keys(jointData).forEach((guid) => {
          let dataTmp = jointData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          jointKeyValue[guid] = dataTmp.Guid;
          newJointData[dataTmp.Guid] = dataTmp;
        });
      }
      copyData.rlJoint = newJointData;
      // 轴线
      let axisKeyValue = {};
      let newAxisData = {};
      let axisData = totalData.rlAxis; //await getRlModules("rlAxis", copyFloorId);
      if (axisData) {
        Object.keys(axisData).forEach((guid) => {
          let dataTmp = axisData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          axisKeyValue[guid] = dataTmp.Guid;
          newAxisData[dataTmp.Guid] = dataTmp;
        });
      }
      copyData.rlAxis = newAxisData;
      // 网格
      let gridKeyValue = {};
      let newGridData = {};
      let gridData = totalData.rlGrid; //await getRlModules("rlGrid", copyFloorId);
      if (gridData) {
        Object.keys(gridData).forEach((guid) => {
          let dataTmp = gridData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          if (dataTmp.Jt0Guid) {
            dataTmp.Jt0Guid = jointKeyValue[dataTmp.Jt0Guid];
          }
          dataTmp.AxisGuid = axisKeyValue[dataTmp.AxisGuid];
          gridKeyValue[guid] = dataTmp.Guid;
          newGridData[dataTmp.Guid] = dataTmp;
        });
      }
      copyData.rlGrid = newGridData;

      //标准层参数
      let StdFlrParaData = totalData.rlStdFlrPara;
      if (StdFlrParaData) {
        StdFlrParaData.forEach((item) => {
          item.StdFlrGuid = copyData.Guid;
        });
      }
      copyData.rlStdFlrPara = StdFlrParaData;
    }
    // 单独设置层高度
    copyData.Height = addHeight ? +addHeight : totalData.Height;

    //将复制数据写入indexdb
    await addrlStdFlr(copyData);
    // 新增标准层的同时新增自然层
    //绘制
    if (bChangeNow) {
      //清空当前画布
      // rlAppObj.rlMxDrawObject.eraseAllMxEntity();
      clearDrawing();
      drawStdFlr(copyData.Guid);
      store.commit("globalData/setStdFlr", copyData.Guid);
    }
    // console.log("copyData123123", copyData);
    return copyData;
  } catch (error) {
    console.error("复制楼层时出错：", error);
  }
};
